(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  /* Scrolls the active category into view on load.

     The nav overflows on a phone, so landing on a later category (Knowledge) left
     its label clipped at the right edge. Section JS only loads where the section
     renders, so this never runs off the blog index.

     Uses getBoundingClientRect deltas rather than offsetLeft: neither the list nor
     the li is positioned, so offsetParent is not a reliable origin here. Only
     scrollLeft is touched, so the page never moves vertically. */
  (function () {
    function centerActiveCategory() {
      var list = document.querySelector('.blog-cats__list');
      if (!list) return;

      var active = list.querySelector('.blog-cats__link--active');
      if (!active) return;
      if (list.scrollWidth <= list.clientWidth) return;

      var listRect = list.getBoundingClientRect();
      var activeRect = active.getBoundingClientRect();

      if (activeRect.left >= listRect.left && activeRect.right <= listRect.right) return;

      list.scrollLeft +=
        activeRect.left - listRect.left - (listRect.width - activeRect.width) / 2;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', centerActiveCategory);
    } else {
      centerActiveCategory();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__colFilterInit) return;
  window.__colFilterInit = true;

  // Keep the sticky bar below the header group; re-run after AJAX swaps.
  function setStickyOffset() {
    var bar = document.querySelector('.filter-bar');
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (bar && headerGroup) bar.style.top = headerGroup.offsetHeight + 'px';
  }
  setStickyOffset();
  window.addEventListener('resize', setStickyOffset);

  function sectionId(selector) {
    var el = document.querySelector(selector);
    return el ? el.getAttribute('data-section-id') : null;
  }

  // Only the newest tap may land. Without this, two quick filter/sort taps race:
  // the slower first answer arrives last, swaps its grid in and pushes its URL,
  // so the page shows the filter the customer just moved away from. A newer
  // navigate() aborts the one in flight; inflightUrl lets a sort change build on
  // the filter that is still loading instead of the stale location.
  var inflight = null;
  var inflightUrl = null;

  // Fetch both sections via the Section Rendering API and swap them in place.
  // push=false is used for popstate so we don't stack history entries.
  function navigate(url, push) {
    var filterId = sectionId('.filter-bar');
    var grid = document.querySelector('.col-grid');
    var gridId = grid ? grid.getAttribute('data-section-id') : null;
    if (!filterId || !gridId) { window.location.href = url; return; }

    var dest = new URL(url, window.location.origin);
    var fetchUrl = new URL(dest.toString());
    fetchUrl.searchParams.set('sections', filterId + ',' + gridId);

    if (grid) grid.classList.add('is-loading');

    if (inflight) inflight.abort();
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    inflight = ctl;
    inflightUrl = dest.toString();
    function superseded() { return !!(ctl && ctl.signal.aborted); }

    fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('Bad response');
        return r.json();
      })
      .then(function (json) {
        if (superseded()) return;
        if (inflight === ctl) { inflight = null; inflightUrl = null; }
        var parser = new DOMParser();
        [filterId, gridId].forEach(function (id) {
          if (json[id] == null) return;
          var target = document.getElementById('shopify-section-' + id);
          if (!target) return;
          var doc = parser.parseFromString(json[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        });
        if (push !== false) history.pushState({ colFilter: true }, '', dest.toString());
        setStickyOffset();
        // The grid is back to page 1 under this URL - drop any run recorded
        // against it, or Back from a product would rebuild pages the customer
        // no longer had open. After the pushState: the key comes from location.
        if (window.colGridPagination) window.colGridPagination.reset();
      })
      .catch(function (err) {
        // An aborted request was replaced by a newer tap - that one owns the page
        // now, so falling back to a full load here would throw its answer away.
        if (superseded() || (err && err.name === 'AbortError')) return;
        if (inflight === ctl) { inflight = null; inflightUrl = null; }
        window.location.href = url;
      });
  }
  window.__collectionFilterNavigate = navigate;

  // Desktop: intercept filter links (dropdown options + applied pills/clear).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    if (!link.closest('.filters-desktop') && !link.closest('.filter-bar__applied')) return;
    if (link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    e.preventDefault();
    navigate(href, true);
  });

  // Sort dropdown change -> AJAX (was a full reload).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.filter-bar__sort-select');
    if (!sel) return;
    var url = new URL(inflightUrl || window.location.href);
    url.searchParams.set('sort_by', sel.value);
    navigate(url.toString(), true);
  });

  // Back/forward navigation re-renders without pushing a new entry.
  window.addEventListener('popstate', function () {
    navigate(window.location.href, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var selections = {};
  var steps = document.querySelectorAll('.finder-quiz__tiles[data-quiz-step]');
  var totalSteps = steps.length;
  var submitBtn = document.querySelector('[data-quiz-submit]');
  var progressEl = document.querySelector('[data-quiz-progress]');
  var root = (submitBtn && submitBtn.closest('.drawer-panel')) || document;

  function updateState() {
    var configured = 0;
    for (var k in selections) {
      if (selections[k]) configured++;
    }
    if (progressEl) {
      progressEl.textContent = configured + ' of ' + totalSteps + ' answered';
    }
    if (submitBtn) {
      submitBtn.disabled = configured < totalSteps;
    }
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-quiz-option]');
    if (!tile) return;
    var grid = tile.closest('.finder-quiz__tiles');
    if (!grid) return;

    grid.querySelectorAll('.finder-quiz__tile').forEach(function (t) {
      t.classList.remove('selected');
    });
    tile.classList.add('selected');

    var step = grid.dataset.quizStep;
    var params = tile.dataset.filterParams;
    selections[step] = params || '';
    updateState();
  });

  var quizView = root.querySelector('[data-finder-quiz]');
  var resultsView = root.querySelector('[data-finder-results]');
  var loadingEl = root.querySelector('[data-finder-loading]');
  var slotEl = root.querySelector('[data-finder-slot]');

  function showQuiz() {
    if (resultsView) resultsView.hidden = true;
    if (quizView) quizView.hidden = false;
  }

  function showResults() {
    if (quizView) quizView.hidden = true;
    if (resultsView) resultsView.hidden = false;
  }

  function renderEmpty() {
    if (slotEl) {
      slotEl.innerHTML =
        '<div class="finder-results__empty">' +
        '<p class="finder-results__empty-text">No exact match - try different answers.</p>' +
        '</div>';
    }
  }

  function resetQuiz() {
    selections = {};
    root.querySelectorAll('.finder-quiz__tile.selected').forEach(function (t) {
      t.classList.remove('selected');
    });
    if (slotEl) slotEl.innerHTML = '';
    updateState();
    showQuiz();
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var parts = [];
      Object.keys(selections).sort().forEach(function (step) {
        if (selections[step]) parts.push(selections[step]);
      });
      if (!parts.length) return;

      var collectionUrl = submitBtn.dataset.collectionUrl || window.location.pathname;
      var host = document.querySelector('.finder-results-host[data-section-id]');
      var sectionId = (host && host.getAttribute('data-section-id')) || submitBtn.dataset.resultsSectionId;

      var dest = collectionUrl + '?' + parts.join('&') + '&sort_by=best-selling';
      if (sectionId) dest += '&section_id=' + encodeURIComponent(sectionId);

      showResults();
      if (loadingEl) loadingEl.hidden = false;
      if (slotEl) slotEl.innerHTML = '';

      fetch(dest, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('.finder-results__grid');
          var empty = doc.querySelector('.finder-results__empty');
          if (loadingEl) loadingEl.hidden = true;
          if (grid && slotEl) {
            slotEl.appendChild(grid);
          } else if (empty && slotEl) {
            slotEl.appendChild(empty);
          } else {
            renderEmpty();
          }
        })
        .catch(function () {
          if (loadingEl) loadingEl.hidden = true;
          renderEmpty();
        });
    });
  }

  document.addEventListener('click', function (e) {
    var restart = e.target.closest('[data-finder-restart]');
    if (!restart || !root.contains(restart)) return;
    resetQuiz();
  });

  updateState();
  showQuiz();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-series-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.series-story__media[data-video-wrap]').forEach((wrap) => {
    const video = wrap.querySelector('.series-story__video');
    const playBtn = wrap.querySelector('.series-story__play');
    if (!video || !playBtn) return;

    function play() {
      wrap.classList.add('series-story__media--playing');
      video.controls = true;
      video.play();
    }

    const poster = wrap.querySelector('[data-video-poster]');
    if (poster) video.addEventListener('playing', () => { poster.hidden = true; }, { once: true });

    playBtn.addEventListener('click', play);
    video.addEventListener('play', () => wrap.classList.add('series-story__media--playing'));
    video.addEventListener('pause', () => wrap.classList.remove('series-story__media--playing'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.col-video__container').forEach((container) => {
    const playBtn = container.querySelector('.col-video__play');
    if (!playBtn) return;

    function activate() {
      const url = container.dataset.videoUrl;
      if (!url) return;

      container.classList.add('col-video__container--playing');

      if (url.includes('youtube') || url.includes('youtu.be')) {
        const id = url.match(/(?:youtu\.be\/|v=)([^&]+)/)?.[1];
        if (id) {
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          iframe.allow = 'autoplay; encrypted-media';
          iframe.allowFullscreen = true;
          container.appendChild(iframe);
        }
      } else if (url.includes('vimeo')) {
        const id = url.match(/vimeo\.com\/(\d+)/)?.[1];
        if (id) {
          const iframe = document.createElement('iframe');
          iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
          iframe.allow = 'autoplay; fullscreen';
          container.appendChild(iframe);
        }
      }
    }

    playBtn.addEventListener('click', activate);
    container.addEventListener('click', (e) => {
      if (e.target === container || e.target.closest('.col-video__poster')) activate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-group"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Build the sidebar once by scanning all groups on the page */
  function buildNav() {
    var groups = document.querySelectorAll('.faq-group');
    var existing = document.querySelector('.faq-nav');
    if (existing) existing.remove();
    if (groups.length < 2) return;

    var nav = document.createElement('nav');
    nav.className = 'faq-nav';
    nav.setAttribute('aria-label', 'FAQ categories');

    var list = document.createElement('ul');
    list.className = 'faq-nav__list';

    groups.forEach(function (group) {
      var title = group.getAttribute('data-faq-title');
      if (!title) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'faq-nav__link';
      a.href = '#' + group.id;
      a.textContent = title;
      a.dataset.target = group.id;
      li.appendChild(a);
      list.appendChild(li);
    });

    nav.appendChild(list);
    document.body.appendChild(nav);

    /* Highlight active category on scroll */
    var links = {};
    nav.querySelectorAll('.faq-nav__link').forEach(function (a) {
      links[a.dataset.target] = a;
    });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            Object.keys(links).forEach(function (id) {
              links[id].classList.toggle('is-active', id === entry.target.id);
            });
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    groups.forEach(function (group) {
      observer.observe(group);
    });
  }

  /* Publish the sticky header's height so the sidebar top + anchor offset clear it */
  function setHeaderOffset() {
    var header = document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('.site-header')
      || document.querySelector('header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--faq-header-offset', h + 'px');
  }

  /* Keep the sidebar inside the FAQ content area (never over the site header or
     footer). In the long middle stretch it is position:fixed so the browser pins
     it with no per-frame JS (no flicker); only at the two ends does JS switch to
     position:absolute to pin it to the content top / bottom. The states meet
     seamlessly because the fixed doc-position equals the absolute one at each end. */
  function positionNav() {
    var nav = document.querySelector('.faq-nav');
    if (!nav || getComputedStyle(nav).display === 'none') return;
    var groups = document.querySelectorAll('.faq-group');
    if (!groups.length) return;
    var y = window.pageYOffset;
    var regionTop = groups[0].getBoundingClientRect().top + y;
    var regionBottom = groups[groups.length - 1].getBoundingClientRect().bottom + y;
    var offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--faq-header-offset'), 10) || 80;
    var inset = 80;          // --space-20: 80px in from the content top/bottom
    var topVp = offset + 16; // pinned viewport position in the sticky zone
    var minDocTop = regionTop + inset;
    var maxDocTop = regionBottom - nav.offsetHeight - inset;
    var fixedDocTop = y + topVp;

    var pos, top;
    if (fixedDocTop <= minDocTop || maxDocTop <= minDocTop) {
      pos = 'absolute'; top = minDocTop;        // above the content / short content
    } else if (fixedDocTop >= maxDocTop) {
      pos = 'absolute'; top = maxDocTop;        // pinned to the content bottom
    } else {
      pos = 'fixed'; top = topVp;               // sticky zone -- browser-pinned
    }
    top = Math.round(top);
    if (nav.__pos !== pos) { nav.style.position = pos; nav.__pos = pos; }
    if (nav.__top !== top) { nav.style.top = top + 'px'; nav.__top = top; }
  }

  var navTicking = false;
  function onScroll() {
    if (navTicking) return;
    navTicking = true;
    window.requestAnimationFrame(function () { positionNav(); navTicking = false; });
  }

  function init() {
    buildNav();
    setHeaderOffset();
    positionNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Opening/closing a panel changes group height -- reposition the sidebar. */
  document.addEventListener('accordion:toggled', function (e) {
    if (e.target.closest('.faq-group')) positionNav();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', positionNav);

  /* Recompute header offset + nav bounds on resize (debounced) */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { setHeaderOffset(); positionNav(); }, 150);
  });

  /* Theme editor: rebuild when a group is added/removed/reordered */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', buildNav);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // ── Mobile menu: animate <details> submenus open/closed (Web Animations API).
    //    Height eases between the summary height and the full panel height; a
    //    mid-flight click reverses smoothly. Reduced-motion falls back to native.
    //    Wired per group when the drawer body is stamped (stamp() below). ──
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var DUR = 320;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function animateGroup(group) {
      var summary = group.querySelector('.mobile-menu__summary');
      var sub = group.querySelector('.mobile-menu__sub');
      if (!summary || !sub) return;

      var animation = null;
      var isClosing = false;
      var isExpanding = false;

      summary.addEventListener('click', function (e) {
        if (reduce.matches || typeof group.animate !== 'function') return; // native instant toggle
        e.preventDefault();
        group.style.overflow = 'hidden';
        if (isClosing || !group.open) {
          openDetails();
        } else if (isExpanding || group.open) {
          shrink();
        }
      });

      function openDetails() {
        // Lock the collapsed (summary) height BEFORE opening, so the rendered
        // content does not make offsetHeight jump straight to the full height.
        group.style.height = group.offsetHeight + 'px';
        group.open = true;
        window.requestAnimationFrame(expand);
      }

      function expand() {
        isExpanding = true;
        var start = group.offsetHeight + 'px';
        var end = summary.offsetHeight + sub.offsetHeight + 'px';
        run(start, end, true);
      }

      function shrink() {
        isClosing = true;
        var start = group.offsetHeight + 'px';
        var end = summary.offsetHeight + 'px';
        run(start, end, false);
      }

      function run(start, end, open) {
        if (animation) animation.cancel();
        animation = group.animate({ height: [start, end] }, { duration: DUR, easing: EASE });
        animation.onfinish = function () { finish(open); };
        // Only clear the flag for this direction; a reversing click owns the other.
        animation.oncancel = function () {
          if (open) { isExpanding = false; } else { isClosing = false; }
        };
      }

      function finish(open) {
        group.open = open;
        animation = null;
        isExpanding = false;
        isClosing = false;
        group.style.height = '';
        group.style.overflow = '';
      }
    }

    document.querySelectorAll('.site-header').forEach(function (header) {
      var id = header.id.replace('site-header-', '');
      var dialog = document.getElementById('mobile-menu-' + id);
      var openBtn = header.querySelector('[data-menu-open]');
      if (!dialog || !openBtn) return;

      // The drawer body ships in a <template>; move it into the dialog the first time the
      // menu opens. Runs before showModal() so the dialog's focusing steps find its first
      // control. The country + language switches are clones of the announcement bar's forms
      // (identical markup apart from the variant class), minus the id the bar copy keeps.
      function stamp() {
        var tpl = dialog.querySelector('template[data-menu-content]');
        if (!tpl) return;
        var body = document.importNode(tpl.content, true);
        var footer = body.querySelector('.mobile-menu__footer');
        var scope = header.parentElement || document;
        if (footer) {
          scope.querySelectorAll('.announcement-bar__end form.lang-switch--bar').forEach(function (form) {
            var copy = form.cloneNode(true);
            copy.removeAttribute('id');
            copy.classList.replace('lang-switch--bar', 'lang-switch--drawer');
            copy.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); });
            footer.appendChild(copy);
          });
        }
        tpl.replaceWith(body);
        dialog.querySelectorAll('.mobile-menu__group').forEach(animateGroup);
      }

      function openMenu() {
        stamp();
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        openBtn.setAttribute('aria-expanded', 'true');
      }
      function closeMenu() {
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      openBtn.addEventListener('click', openMenu);
      // Stamp on press, so the clone is done in the gap before the click lands and the
      // first open costs the same as when the body was always in the DOM.
      openBtn.addEventListener('pointerdown', stamp, { passive: true });

      // Native dialog ESC / close keeps the toggle's aria state in sync.
      dialog.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
      });

      // Tap the close button, a real link or the ::backdrop to close. Delegated, because the
      // close button only exists once the drawer body has been stamped.
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-menu-close]')) {
          closeMenu();
          return;
        }
        var link = e.target.closest('a[href]');
        if (link && link.getAttribute('href') !== '#') closeMenu();
      });
    });

    // ── Desktop mega-menu: ONE persistent panel. The whole nav is the hover zone -
    //    links, the gaps between them, and the panels all live inside .header__nav,
    //    so sliding between top-level items never leaves the nav and never closes.
    //    A mouseover delegate just swaps which panel shows. ──
    var megaItems = document.querySelectorAll('[data-mega]');
    var siteHeader = document.querySelector('.site-header');
    var nav = document.querySelector('.header__nav');
    var openItem = null;
    var closeTimer;

    function panelOf(item) { return item.querySelector('[data-mega-panel]'); }
    function toggleOf(item) { return item.querySelector('[aria-controls]'); }

    function setItemOpen(item, isOpen) {
      var panel = panelOf(item);
      var toggle = toggleOf(item);
      if (!panel || !toggle) return;
      panel.hidden = !isOpen;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function showMega(item) {
      clearTimeout(closeTimer);
      if (item === openItem) return;
      // Fresh open (was fully closed) cascades the tiles; a switch swaps instantly.
      var fresh = openItem === null;
      megaItems.forEach(function (other) { if (other !== item) setItemOpen(other, false); });
      var panel = panelOf(item);
      if (panel) panel.classList.toggle('is-fresh', fresh);
      setItemOpen(item, true);
      openItem = item;
      // Size the shared frost to the now-visible panel; it persists and morphs.
      if (siteHeader && panel) siteHeader.style.setProperty('--mega-frost-h', panel.offsetHeight + 'px');
    }

    function hideMega() {
      clearTimeout(closeTimer);
      megaItems.forEach(function (item) { setItemOpen(item, false); });
      openItem = null;
      if (siteHeader) siteHeader.style.removeProperty('--mega-frost-h');
    }

    function hideMegaSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(hideMega, 160);
    }

    if (nav) {
      nav.addEventListener('mouseover', function (e) {
        var item = e.target.closest('[data-mega]');
        if (item) {
          showMega(item);
        } else if (e.target.closest('.header__nav-item')) {
          // Hovering a top-level link that has no mega: close any open panel.
          hideMegaSoon();
        }
        // Over the gaps / nav background: leave the current panel as-is.
      });
      // Leaving the nav entirely (the panels are descendants) closes; re-entering cancels.
      nav.addEventListener('mouseleave', hideMegaSoon);
      nav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    }

    megaItems.forEach(function (item) {
      var toggle = toggleOf(item);
      if (!toggle) return;

      // Click/tap always opens (touch has no hover); close via outside-tap / ESC.
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        showMega(item);
      });

      // Keyboard: open on focus in, close when focus leaves the item entirely.
      item.addEventListener('focusin', function () { showMega(item); });
      item.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (openItem === item && !item.contains(document.activeElement)) hideMega();
        });
      });
    });

    // Click outside the open item closes it.
    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) hideMega();
    });

    // ESC closes and returns focus to the open item's toggle.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var toggle = toggleOf(openItem);
      hideMega();
      if (toggle) toggle.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection-slider"] && !Shopify.designMode) return;
  try {
    
  /* First mouse or pen contact with a collection slider gives its hover images a
     box (.is-hover-warm), which is what hands them to the lazy loader - see the
     .hp-coll__img--hover rule. Touch input never sets it. One delegated listener,
     so it also covers sections the theme editor re-renders. */
  (function () {
    document.addEventListener('pointerover', function (event) {
      if (event.pointerType === 'touch' || !event.target.closest) return;
      var slider = event.target.closest('.hp-coll');
      if (slider) slider.classList.add('is-hover-warm');
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-latest"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('latest-tiles')) {
    customElements.define(
      'latest-tiles',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('video'));
          if (this.videos.length === 0) return;

          // Force the muted property (not just the attribute) so browsers treat
          // the videos as autoplay-eligible.
          this.videos.forEach((v) => {
            v.muted = true;
          });

          // Respect reduced-motion: never start the clips. The markup has no
          // `autoplay` and preload="none", so nothing has loaded and the lazy poster
          // image stays up as the still frame.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          // Take the lazy poster image down on the first `playing` event, once a real
          // frame is on screen. If play() is refused (iOS Low Power Mode) it stays.
          this.videos.forEach((v) => {
            const poster = v.parentNode && v.parentNode.querySelector('[data-video-poster]');
            if (!poster) return;
            v.addEventListener(
              'playing',
              () => {
                poster.hidden = true;
              },
              { once: true }
            );
          });

          // Only play while in view: the markup carries no `autoplay`, so nothing
          // loads or plays until a tile is at least a quarter on screen, and tiles
          // scrolled past pause to save bandwidth/battery.
          if (!('IntersectionObserver' in window)) {
            this.videos.forEach((v) => {
              const p = v.play();
              if (p) p.catch(() => {});
            });
            return;
          }

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const v = entry.target;
                if (entry.isIntersecting) {
                  const p = v.play();
                  if (p) p.catch(() => {});
                } else {
                  v.pause();
                }
              });
            },
            { threshold: 0.25 }
          );

          this.videos.forEach((v) => this.io.observe(v));
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-sustainability"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('circular-story')) {
    customElements.define(
      'circular-story',
      class extends HTMLElement {
        connectedCallback() {
          this.panelWrap = this.querySelector('.hp-circular__panels');
          // Must run before the tabs are collected - they don't live in the
          // tablist yet, each tab block ships its own button beside its panel.
          this.hoistTabs();
          this.tabs = Array.from(this.querySelectorAll('.hp-circular__tab'));
          this.panels = Array.from(this.querySelectorAll('.hp-circular__panel'));
          this.setupVideos();
          // Take the panels off the CSS fallback and onto [hidden] before
          // setupArrows() runs - it measures whichever panel is showing.
          this.showActive();
          this.setupArrows();
          if (this.tabs.length > 1 && this.panels.length > 1) this.setupTabs();
        }

        // Move each block's switcher button into the section's tablist, in DOM
        // order, so the tabs read in the order the merchant arranged them.
        hoistTabs() {
          const list = this.querySelector('.hp-circular__tabs');
          if (!list || !this.panelWrap) return;
          this.panelWrap.querySelectorAll('.hp-circular__tab').forEach((tab) => {
            list.appendChild(tab);
            tab.hidden = false;
          });
        }

        // First tab wins on load; the panels follow it.
        showActive() {
          if (!this.tabs.length || !this.panels.length) return;
          this.select(this.tabs[0].dataset.tab, false);
          if (this.panelWrap) this.panelWrap.setAttribute('data-ready', '');
        }

        setupTabs() {
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
            tab.addEventListener('keydown', (event) => this.onKey(event));
          });
        }

        // Header prev/next arrows drive whichever panel's track is currently
        // visible (mirrors collection-tab-slider). Revealed only >=750px and when
        // the active track overflows; below that the track is swiped by touch.
        setupArrows() {
          this.nav = this.querySelector('.hp-circular__nav');
          this.prevBtn = this.nav && this.nav.querySelector('[data-dir="prev"]');
          this.nextBtn = this.nav && this.nav.querySelector('[data-dir="next"]');
          if (!this.nav || !this.prevBtn || !this.nextBtn) return;

          this.mq = window.matchMedia('(min-width: 750px)');
          this.updateArrows = this.updateArrows.bind(this);

          this.prevBtn.addEventListener('click', () => this.page(-1));
          this.nextBtn.addEventListener('click', () => this.page(1));
          this.panels.forEach((panel) => {
            const track = panel.querySelector('[data-scroll-rail-track]');
            if (track) track.addEventListener('scroll', this.updateArrows, { passive: true });
          });
          window.addEventListener('resize', this.updateArrows, { passive: true });
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.updateArrows);

          this.updateArrows();
          this.nav.classList.add('is-ready');
        }

        activeTrack() {
          const panel = this.panels.find((p) => !p.hidden) || this.panels[0];
          return panel ? panel.querySelector('[data-scroll-rail-track]') : null;
        }

        page(direction) {
          const track = this.activeTrack();
          if (!track) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: direction * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        }

        updateArrows() {
          if (!this.nav || !this.mq) return;
          const track = this.activeTrack();
          const scrollable = track && ['auto', 'scroll'].includes(getComputedStyle(track).overflowX);
          const max = track ? track.scrollWidth - track.clientWidth : 0;
          const overflows = !!track && scrollable && this.mq.matches && max > 1;
          this.nav.toggleAttribute('data-overflow', overflows);
          this.prevBtn.disabled = !overflows || track.scrollLeft <= 1;
          this.nextBtn.disabled = !overflows || track.scrollLeft >= max - 1;
        }

        select(tab, focus) {
          this.tabs.forEach((el) => {
            const on = el.dataset.tab === tab;
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-selected', on ? 'true' : 'false');
            el.tabIndex = on ? 0 : -1;
            if (on && focus) el.focus();
          });
          this.panels.forEach((panel) => {
            const on = panel.dataset.tab === tab;
            panel.hidden = !on;
            // Pause + reset any videos in the panels we just hid.
            if (!on) {
              panel.querySelectorAll('video').forEach((video) => {
                if (!video.paused) video.pause();
              });
              panel.querySelectorAll('.hp-circular__play').forEach((btn) => {
                btn.style.opacity = '1';
                const icon = btn.querySelector('i');
                if (icon) icon.className = 'ph ph-play-circle';
              });
            }
          });
          this.updateArrows();
        }

        // Roving-tabindex keyboard support across the tablist.
        onKey(event) {
          const i = this.tabs.indexOf(event.target);
          if (i < 0) return;
          let next = -1;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (next < 0) return;
          event.preventDefault();
          this.select(this.tabs[next].dataset.tab, true);
        }

        setupVideos() {
          this.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
            const video = wrap.querySelector('video');
            const btn = wrap.querySelector('.hp-circular__play');
            if (!video || !btn) return;
            const icon = btn.querySelector('i');
            // The step's lazy poster image covers the video (preload="none", so it
            // has no frame of its own) until the first `playing` event.
            const poster = wrap.querySelector('[data-video-poster]');
            if (poster) {
              video.addEventListener(
                'playing',
                () => {
                  poster.hidden = true;
                },
                { once: true }
              );
            }

            wrap.addEventListener('click', () => {
              if (video.paused) {
                video.play().catch(() => {});
                btn.style.opacity = '0';
                if (icon) icon.className = 'ph ph-pause-circle';
              } else {
                video.pause();
                btn.style.opacity = '1';
                if (icon) icon.className = 'ph ph-play-circle';
              }
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  var __pdpData = document.querySelector('[data-i18n-atc]');
  var I18N = {
    addToCart: (__pdpData && __pdpData.dataset.i18nAtc) || 'Add to cart',
    soldOut: (__pdpData && __pdpData.dataset.i18nSoldOut) || 'Sold out',
    notifyMe: ((__pdpData && __pdpData.dataset.i18nNotify) || 'Notify me').trim(),
    lowStock: (__pdpData && __pdpData.dataset.i18nLowStock) || 'Only {count} left',
    sizesOosOne: (__pdpData && __pdpData.dataset.i18nSizesOosOne) || '1 size sold out',
    sizesOosOther: (__pdpData && __pdpData.dataset.i18nSizesOosOther) || '{count} sizes sold out',
    selectSize: (__pdpData && __pdpData.dataset.i18nSelectSize) || 'Select a size',
    sizeNotInColor: (__pdpData && __pdpData.dataset.i18nSizeNotInColor) || '{size} is not available in {color}'
  };
(function () {
  var gallery = document.getElementById('pdp-gallery');
  var activeMediaIdx = 0;

  /* Mobile pager. The counter markup is never re-rendered (fetchGallery only
     swaps the slides and the thumb rail), so these references stay valid for the
     life of the page and the click handlers are bound once, below. */
  var counterEl = document.getElementById('gallery-counter');
  var counterCurrent = document.querySelector('[data-gallery-current]');
  var counterTotal = document.querySelector('[data-gallery-total]');
  var counterPrev = document.querySelector('[data-gallery-prev]');
  var counterNext = document.querySelector('[data-gallery-next]');

  function setActiveMedia(idx) {
    activeMediaIdx = idx;
    document.querySelectorAll('.gallery-item').forEach(function (el) {
      el.classList.remove('is-active');
    });
    document.querySelectorAll('[data-thumb-idx]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    var item = document.querySelector('[data-gallery-idx="' + idx + '"]');
    if (item) {
      item.classList.add('is-active');
      revealMedia(item);
    }
    var thumb = document.querySelector('[data-thumb-idx="' + idx + '"]');
    if (thumb) thumb.classList.add('is-active');
    updateGalleryCounter();
  }

  function updateGalleryCounter() {
    if (!counterEl) return;
    /* Read the live count - a variant swap replaces the slide set. */
    var total = document.querySelectorAll('.gallery-item').length;
    /* A single-media variant has nothing to page through. Clearing the inline
       style (rather than setting a value) hands display back to the media query,
       so the counter stays desktop-hidden. */
    counterEl.style.display = total > 1 ? '' : 'none';
    if (counterCurrent) counterCurrent.textContent = activeMediaIdx + 1;
    if (counterTotal) counterTotal.textContent = total;
    if (counterPrev) counterPrev.disabled = activeMediaIdx <= 0;
    if (counterNext) counterNext.disabled = activeMediaIdx >= total - 1;
  }

  function goToMedia(idx) {
    var total = document.querySelectorAll('.gallery-item').length;
    if (idx < 0 || idx >= total) return;
    pauseAllVideos();
    setActiveMedia(idx);
    /* The smooth scroll below lands on idx without the scroll handler seeing a
       new index, so warm the next slide here. */
    warmMedia(idx + 1);
    /* Mobile only - the desktop gallery has overflow: visible, and the counter
       that calls this is display: none there anyway. */
    if (gallery) gallery.scrollTo({ left: idx * gallery.offsetWidth, behavior: 'smooth' });
  }

  if (counterPrev) {
    counterPrev.addEventListener('click', function () { goToMedia(activeMediaIdx - 1); });
  }
  if (counterNext) {
    counterNext.addEventListener('click', function () { goToMedia(activeMediaIdx + 1); });
  }

  /* Show the shimmer skeleton until the target image is decoded and paint-ready,
     then fade it out. Prevents the first-view blink/thumbnail jump caused by the
     browser decoding a previously display:none slide on the fly. Already-decoded
     (cached) images resolve synchronously, so the skeleton never flashes. */
  function revealMedia(item) {
    var img = item.querySelector('.gallery-img');
    if (!img || img.dataset.decoded === '1') return;
    /* Slides 2+ render loading="lazy". Start the fetch of a slide being shown
       now rather than after the browser's lazy-load check catches up with it.
       decode() resolves once it has loaded; the shimmer covers the wait. */
    if (img.loading === 'lazy') img.loading = 'eager';
    if (typeof img.decode !== 'function') {
      img.dataset.decoded = '1';
      return;
    }
    item.classList.add('is-loading');
    img.decode().then(function () {
      img.dataset.decoded = '1';
    }).catch(function () {
      /* decode() can reject on some formats; reveal the image anyway */
    }).then(function () {
      item.classList.remove('is-loading');
    });
  }

  /* Warm-up for the lazy slides 2+: start a slide's download as soon as the
     shopper signals intent (thumb hover/focus, a touch on the swipe gallery, the
     slide before it being shown), so it is usually decoded before it is shown.
     Only flips loading - no-op for a slide that is already eager or loaded, and
     for video slides. */
  function warmMedia(idx) {
    var item = document.querySelector('[data-gallery-idx="' + idx + '"]');
    var img = item && item.querySelector('.gallery-img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  }

  /* Touch screens in the thumbnail layout (iPads in landscape, 960px and up)
     get no hover warm-up: pointerenter fires in the same tap as the click, and
     that layout has no swipe. Warm the slide after the active one for them -
     once the page is idle and after every thumb tap or variant switch - so a
     tap on the next thumb does not wait for a cold download. Mouse users keep
     the hover warm-up and download nothing extra. The rail's own display is
     the layout test, so this follows the CSS breakpoint. */
  function warmNextForTouch() {
    if (!window.matchMedia || !window.matchMedia('(any-pointer: coarse)').matches) return;
    var rail = document.querySelector('.pdp-thumb-rail');
    if (!rail || getComputedStyle(rail).display === 'none') return;
    warmMedia(activeMediaIdx + 1);
  }

  /* Mobile: native swipe drives the active thumbnail. Desktop gallery does not
     scroll (overflow visible), so this listener only fires on mobile. */
  if (gallery) {
    gallery.addEventListener('scroll', function () {
      var idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
      if (idx === activeMediaIdx) return;
      setActiveMedia(idx);
      warmMedia(idx + 1);
      pauseAllVideos();
    });
    /* The scroller's own lazy margin usually has the next slide loaded already;
       this covers browsers that do not apply one inside a horizontal scroller. */
    gallery.addEventListener('touchstart', function () {
      warmMedia(activeMediaIdx + 1);
    }, { passive: true });
  }

  function pauseAllVideos() {
    document.querySelectorAll('.gallery-video').forEach(function (v) {
      if (v.tagName === 'VIDEO' && !v.paused) v.pause();
      var wrap = v.closest('.gallery-video-wrap');
      if (wrap) wrap.classList.remove('is-playing');
    });
  }

  function initGallerySkeleton() {
    document.querySelectorAll('.gallery-item').forEach(function (item) {
      var img = item.querySelector('.gallery-img');
      if (!img) return;
      if (img.complete && img.naturalWidth > 0) {
        img.dataset.decoded = '1';
        return;
      }
      /* First-load: skeleton the slide that is visible on arrival. */
      if (item.classList.contains('is-active')) item.classList.add('is-loading');
      img.addEventListener('load', function () {
        img.dataset.decoded = '1';
        item.classList.remove('is-loading');
      });
      img.addEventListener('error', function () {
        item.classList.remove('is-loading');
      });
    });
  }

  function initThumbnails() {
    document.querySelectorAll('[data-thumb-idx]').forEach(function (btn) {
      function warm() { warmMedia(parseInt(btn.dataset.thumbIdx, 10) || 0); }
      btn.addEventListener('pointerenter', warm);
      btn.addEventListener('focus', warm);
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.thumbIdx, 10) || 0;
        pauseAllVideos();
        setActiveMedia(idx);
        /* Shoppers step through thumbs in order: have the next one ready for a
           tap. A mouse gets it from hovering that thumb, at no extra cost. */
        warmNextForTouch();
        /* Mobile: scroll the native swipe carousel to the chosen media.
           No-op on desktop, where the gallery has overflow: visible. */
        gallery.scrollTo({ left: idx * gallery.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  function initVideoPlayers() {
    document.querySelectorAll('.gallery-play-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.gallery-video-wrap');
        if (!wrap) return;
        var video = wrap.querySelector('video');
        if (video) {
          video.play();
          wrap.classList.add('is-playing');
        }
        var iframe = wrap.querySelector('iframe');
        if (iframe) {
          var src = iframe.src;
          if (src.indexOf('youtube') > -1) {
            iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          } else if (src.indexOf('vimeo') > -1) {
            iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          }
          wrap.classList.add('is-playing');
        }
      });
    });

    document.querySelectorAll('.gallery-video-wrap video').forEach(function (v) {
      v.addEventListener('pause', function () {
        var wrap = v.closest('.gallery-video-wrap');
        if (wrap) wrap.classList.remove('is-playing');
      });
      v.addEventListener('ended', function () {
        var wrap = v.closest('.gallery-video-wrap');
        if (wrap) wrap.classList.remove('is-playing');
      });
    });
  }

  initGallerySkeleton();
  initThumbnails();
  initVideoPlayers();
  updateGalleryCounter();

  /* After load and once idle, so the touch warm-up never competes with the
     first slide or anything else on the critical path. */
  function warmNextForTouchWhenIdle() {
    if ('requestIdleCallback' in window) requestIdleCallback(warmNextForTouch, { timeout: 2000 });
    else setTimeout(warmNextForTouch, 200);
  }
  if (document.readyState === 'complete') warmNextForTouchWhenIdle();
  else window.addEventListener('load', warmNextForTouchWhenIdle);

  /* ── Variant selection ── */

  var dataEl = document.getElementById('pdp-variant-data');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent);

  var specDataEl = document.getElementById('pdp-spec-data');
  var specMap = specDataEl ? JSON.parse(specDataEl.textContent) : {};

  var priceDataEl = document.getElementById('pdp-price-data');
  var priceMap = priceDataEl ? JSON.parse(priceDataEl.textContent) : {};

  // money_format carries HTML entities for several currencies - the amount
  // placeholder is commonly followed by a non-breaking-space entity plus the
  // symbol (e.g. "1 980 kr"), so the symbol never wraps onto its own line.
  // Those strings are assigned straight to textContent on the add-to-cart
  // button, which would print the raw entity, so decode once up front and hand
  // every sink plain text.
  (function decodePriceMap() {
    var scratch = document.createElement('textarea');
    Object.keys(priceMap).forEach(function (id) {
      Object.keys(priceMap[id]).forEach(function (field) {
        var value = priceMap[id][field];
        if (typeof value === 'string' && value.indexOf('&') !== -1) {
          scratch.innerHTML = value;
          priceMap[id][field] = scratch.value;
        }
      });
    });
  })();

  var preorderDataEl = document.getElementById('pdp-preorder-data');
  var preorderMap = preorderDataEl ? JSON.parse(preorderDataEl.textContent) : {};
  var stockAltDataEl = document.getElementById('pdp-stock-alt-data');
  var stockAltMap = stockAltDataEl ? JSON.parse(stockAltDataEl.textContent) : {};
  var hero = document.querySelector('[data-product-url]');
  var productUrl = hero ? hero.dataset.productUrl : window.location.pathname;
  var productTitle = hero ? hero.dataset.productTitle : '';
  var hiddenInput = document.querySelector('input[name="id"]');
  var atcBtn = document.querySelector('.buy-atc-btn');
  var priceGroup = document.getElementById('pdp-price-group');
  var eyebrowVariant = document.getElementById('eyebrow-variant');
  var thumbRail = document.querySelector('.pdp-thumb-rail');
  // Colour and size are addressed by their real option position, never by a hardcoded
  // option1/option2 - a product may be Size-only, or list Size before Color. 0 means the
  // product has no such option, which is what makes optValue() return null for it.
  var colorPos = parseInt(dataEl.dataset.colorPosition, 10) || 0;
  var sizePos = parseInt(dataEl.dataset.sizePosition, 10) || 0;
  var hasColorOption = colorPos > 0;
  // Artist rows (one discounted product, one motif per swatch) carry no sale dots.
  var noSaleDots = !!document.querySelector('.swatch-row[data-no-sale-dots]');
  var hasSizeOption = sizePos > 0;
  var lowStockThreshold = parseInt(dataEl.dataset.lowStockThreshold, 10) || 5;

  function optValue(v, pos) {
    return pos ? v['option' + pos] : null;
  }

  function findVariant(color, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (hasColorOption && hasSizeOption) {
        if (optValue(v, colorPos) === color && (size === null || optValue(v, sizePos) === size)) return v;
      } else if (hasColorOption) {
        if (optValue(v, colorPos) === color) return v;
      } else if (hasSizeOption) {
        if (optValue(v, sizePos) === size) return v;
      } else {
        return v;
      }
    }
    return null;
  }

  // Prices come from Liquid pre-formatted per variant (see #pdp-price-data), so
  // the currency and separators always match the visitor's market - the raw
  // cents in the variants JSON carry no currency and must never be formatted
  // with a fixed symbol here.
  function moneyFor(variant, field) {
    var entry = priceMap[String(variant.id)];
    if (entry && entry[field]) return entry[field];
    return formatMoney(variant[field]);
  }

  // Fallback only: a variant missing from the map (or a raw amount with no
  // variant context). Uses the active presentment currency rather than a
  // hardcoded symbol.
  function formatMoney(cents) {
    if (cents === null || cents === undefined || !isFinite(cents)) return '';
    var cur = window.Shopify && window.Shopify.currency;
    var active = (cur && cur.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: active
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + active;
    }
  }

  /* Mirror of snippets/price.liquid: price, struck compare-at, "-N%" badge,
     the percentage rounded to the nearest whole number like the snippet.
     Money strings come pre-formatted from Liquid via moneyFor(). */
  function priceHtml(variant, modifier) {
    var html = '<span class="price' + (modifier ? ' ' + modifier : '') + '">' +
      '<span class="price__now">' + moneyFor(variant, 'price') + '</span>';
    var compare = variant.compare_at_price;
    if (compare && compare > variant.price) {
      html += ' <s class="price__was">' + moneyFor(variant, 'compare_at_price') + '</s>';
      var pct = Math.round((compare - variant.price) * 100 / compare);
      if (pct > 0) html += ' <span class="price__badge">-' + pct + '%</span>';
    }
    return html + '</span>';
  }

  /* assets/cart.js snapshots a buy button's label (data-idle-label) on the
     first add and puts that snapshot back after "Added". Keep the snapshot on
     the current variant, or an add after a variant switch would bring back the
     earlier variant's price. data-idle-disabled is the same for the disabled
     state: cart.js restores it when the "Added" / error feedback ends, so a
     switch to a sold-out variant (or a colour without the chosen size) during
     that window stays disabled. Callers set btn.disabled BEFORE calling this. */
  function setAtcLabel(btn, text) {
    btn.dataset.idleDisabled = btn.disabled ? 'true' : 'false';
    var span = btn.querySelector('span');
    if (!span) return;
    span.textContent = text;
    if (btn.dataset.idleLabel !== undefined) btn.dataset.idleLabel = span.innerHTML;
  }

  function updateUI(variant) {
    if (!variant) return;
    if (hiddenInput) hiddenInput.value = variant.id;

    if (priceGroup) priceGroup.innerHTML = priceHtml(variant, 't-price price--lg');

    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        setAtcLabel(atcBtn, I18N.addToCart + ' - ' + moneyFor(variant, 'price'));
      } else {
        atcBtn.disabled = true;
        setAtcLabel(atcBtn, I18N.soldOut);
      }
    }

    var stickyVariantInput = document.getElementById('sticky-bar-variant-id');
    var stickyAtcBtn = document.getElementById('sticky-bar-atc');
    var stickyPrice = document.getElementById('sticky-bar-price');

    if (stickyVariantInput) stickyVariantInput.value = variant.id;

    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = !variant.available;
      setAtcLabel(stickyAtcBtn, variant.available ? I18N.addToCart : I18N.soldOut);
    }

    if (stickyPrice) stickyPrice.innerHTML = priceHtml(variant, '');

    var stickyMeta = document.getElementById('sticky-bar-meta');
    if (stickyMeta) {
      var parts = [];
      var seriesName = stickyMeta.dataset.series;
      if (seriesName) parts.push(seriesName);
      // Positional on purpose: options in author order, not resolved by colour/size role.
      // Products with no real options carry Shopify's synthetic "Default Title" variant,
      // whose option1 is the literal string "Default Title" - never show it.
      if (variant.title !== 'Default Title') {
        if (variant.option1) parts.push(variant.option1);
        if (variant.option2) parts.push(variant.option2);
      }
      stickyMeta.textContent = parts.join(' - ');
    }

    if (eyebrowVariant) {
      eyebrowVariant.textContent = variant.title !== 'Default Title' ? ' - ' + variant.title : '';
    }

    updateLowStockBadge(variant);
    updateSpecStrip(variant);
    updatePreorder(variant);
    updateStockAlt(variant);
    updateSwatchSaleDots(variant);
    updateStatusLabel(variant);
    history.replaceState({}, '', productUrl + '?variant=' + variant.id);
    syncBackInStock(variant);
  }

  // The label beside the title follows the selected variant - same priority as the
  // Liquid render: SOLD OUT > SALE > NEW (data-new is empty unless tagged "new").
  function updateStatusLabel(variant) {
    var label = document.getElementById('buy-status');
    if (!label) return;
    var text = '';
    if (!variant.available) text = label.dataset.soldOut;
    else if (variant.compare_at_price && variant.compare_at_price > variant.price) text = label.dataset.sale;
    else text = label.dataset.new;
    label.textContent = text || '';
    label.classList.toggle('status-label--sold-out', !variant.available);
    label.hidden = !text;
  }

  // Back in Stock (Shop Circle app block, rendered in the buy box). The app reads the
  // selected variant from ?variant= (set just above), else the form's hidden id, and
  // re-checks only on a native change event from that form - a programmatic value
  // write never fires one, so without this the notify form stayed on the variant the
  // page loaded with. It redraws ~1 s after the event and then fires
  // esc-out-of-stock-loaded. Only once it has drawn its form at least once does a
  // sold-out variant hide our disabled button and express checkout (.is-notify); a
  // blocked or failed app script leaves the "Sold out" button in place. The sticky
  // bar's button turns into "Notify me" and scrolls to the form.
  var bisBlock = document.querySelector('.buy-app-block [data-app="esc-out-of-stock"]');
  var atcSection = document.getElementById('atc-section');
  var bisReady = false;
  var bisSoldOut = variants.some(function (v) {
    return hiddenInput && String(v.id) === hiddenInput.value && !v.available;
  });
  function applyNotifyState() {
    var notify = bisReady && bisSoldOut;
    if (atcSection) atcSection.classList.toggle('is-notify', notify);
    var sticky = document.getElementById('sticky-bar-atc');
    if (!sticky) return;
    if (notify) {
      sticky.disabled = false;
      sticky.dataset.notify = 'true';
      setAtcLabel(sticky, I18N.notifyMe);
    } else if (sticky.dataset.notify) {
      // Leaving the notify state: the label/disabled state was set by updateUI.
      delete sticky.dataset.notify;
    }
  }
  function syncBackInStock(variant) {
    if (!bisBlock) return;
    bisSoldOut = !variant.available;
    if (hiddenInput) hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    applyNotifyState();
  }
  if (bisBlock) {
    window.addEventListener('esc-out-of-stock-loaded', function () {
      bisReady = true;
      applyNotifyState();
    });
    var stickyForNotify = document.getElementById('sticky-bar-atc');
    if (stickyForNotify) {
      stickyForNotify.addEventListener('click', function (e) {
        if (!stickyForNotify.dataset.notify) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        bisBlock.closest('.buy-app-block').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }
  }

  // The colour swatches' "%" dots are scoped to the CURRENTLY SELECTED size
  // (a colour can be on sale in one size and not another), so a size change
  // must refresh every dot, not just the price - mirrors the Liquid
  // resolution above ("this colour at this size, else any variant of it").
  function updateSwatchSaleDots(variant) {
    if (!hasColorOption || noSaleDots) return;
    var size = hasSizeOption ? optValue(variant, sizePos) : null;
    document.querySelectorAll('.swatch-btn[data-color]').forEach(function (btn) {
      var color = btn.dataset.color;
      var v = findVariant(color, size);
      if (!v) v = findVariant(color, null);
      var existing = btn.querySelector('.swatch-sale');
      // A struck-through (sold-out) colour never carries the dot - same rule as the Liquid.
      var onSale = !btn.classList.contains('is-sold-out') &&
        !!(v && v.compare_at_price && v.compare_at_price > v.price);
      if (onSale && !existing) {
        var dot = document.createElement('span');
        dot.className = 'swatch-sale';
        dot.setAttribute('aria-hidden', 'true');
        dot.textContent = '%';
        btn.appendChild(dot);
      } else if (!onSale && existing) {
        existing.remove();
      }
    });
  }

  // Format a shop-currency minor-unit amount (e.g. 500 = 5.00 EUR) for display,
  // converting to the visitor's presentment currency when it differs from the
  // shop currency. Shopify does not convert metafield values, so we apply
  // Shopify.currency.rate ourselves - mirroring assets/shipping-threshold.js.
  function formatPreorderAmount(raw, shopCurrency) {
    var cents = parseFloat(raw);
    if (!isFinite(cents)) return '';
    var cur = window.Shopify && window.Shopify.currency;
    var active = (cur && cur.active) || shopCurrency;
    var rate = cur ? parseFloat(cur.rate || '1') : 1;
    if (active !== shopCurrency && isFinite(rate) && rate > 0) {
      cents = cents * rate;
    } else {
      active = shopCurrency;
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: active
      }).format(cents / 100);
    } catch (e) {
      return formatMoney(cents);
    }
  }

  function updatePreorder(variant) {
    var el = document.getElementById('buy-preorder');
    if (!el) return;
    var data = preorderMap[String(variant.id)];
    if (!data || !data.on) { el.style.display = 'none'; return; }
    var body = el.querySelector('[data-preorder-body]');
    if (body) {
      var amount = data.amount === '' || data.amount == null
        ? ''
        : formatPreorderAmount(data.amount, el.dataset.shopCurrency || 'EUR');
      var strong = function (s) { return s ? '<strong>' + s + '</strong>' : ''; };
      // Mirror of the Liquid logic above: the [if discount]...[/if] block survives only
      // when this variant has both a code and an amount.
      var tpl = el.dataset.preorderTemplate || '';
      tpl = (data.code && amount)
        ? tpl.replace(/\[if discount\]|\[\/if\]/g, '')
        : tpl.replace(/\[if discount\][\s\S]*?\[\/if\]/g, '');
      body.innerHTML = tpl
        .replace(/\[preorder date\]/g, strong(data.date))
        .replace(/\[preorder code\]/g, strong(data.code))
        .replace(/\[amount\]/g, strong(amount));
    }
    el.style.display = '';
  }

  // Initial paint: run once for the selected variant so the amount renders in
  // the visitor's currency on load (updatePreorder otherwise only fires on
  // variant change). Harmless for non-preorder variants (hides the block).
  (function initPreorder() {
    var el = document.getElementById('buy-preorder');
    if (!el || !variants.length) return;
    var vid = hiddenInput ? hiddenInput.value : null;
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) { v = variants[i]; break; }
    }
    updatePreorder(v || variants[0]);
  })();

  // The sentence is precomputed per variant in Liquid (see
  // snippets/pdp-stock-alternative.liquid), so this only swaps it in - no copy,
  // no translations, and no availability logic on the JS side. Liquid already
  // rendered the state for the variant on load, so there is no init pass.
  function updateStockAlt(variant) {
    var slots = document.querySelectorAll('[data-stock-alt]');
    if (!slots.length) return;
    var data = variant ? stockAltMap[String(variant.id)] : null;
    // Fill only the slot this variant belongs to and clear the other. A switch
    // between a preorder variant and a sold-out one moves the line between
    // slots, so the losing slot must be emptied, not just left behind.
    slots.forEach(function (el) {
      var match = !!(data && data.html && data.slot === el.dataset.stockAlt);
      el.innerHTML = match ? data.html : '';
      el.hidden = !match;
    });
  }

  // Clicking the suggestion switches variant in place instead of reloading. It
  // drives the existing swatch and size buttons rather than duplicating their
  // orchestration, so the gallery, sticky bar and pdp:variant-change listeners
  // all stay in sync. If neither control matches, we do NOT preventDefault and
  // the anchor's real ?variant= href takes over - so the link is never dead.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('[data-stock-alt] a[data-stock-alt-id]');
    if (!link) return;

    var target = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === link.dataset.stockAltId) { target = variants[i]; break; }
    }
    if (!target) return;

    var values = [target.option1, target.option2, target.option3];
    var colorBtn = null;
    var sizeBtn = null;
    document.querySelectorAll('.swatch-btn').forEach(function (b) {
      if (!colorBtn && values.indexOf(b.dataset.color) !== -1) colorBtn = b;
    });
    document.querySelectorAll('.size-btn').forEach(function (b) {
      if (!sizeBtn && values.indexOf(b.dataset.size) !== -1) sizeBtn = b;
    });
    if (!colorBtn && !sizeBtn) return;

    e.preventDefault();
    // Colour first: its handler resets the size selection.
    if (colorBtn && !colorBtn.classList.contains('is-active')) colorBtn.click();
    if (sizeBtn && !sizeBtn.classList.contains('is-active')) sizeBtn.click();

    // The line the shopper just clicked is removed once the new variant is
    // buyable, which would drop focus to <body>. Send it to the buy button,
    // which is the action they were reaching for.
    var atc = document.querySelector('.buy-atc-btn');
    if (atc) atc.focus();
  });

  function updateSpecStrip(variant) {
    var specs = specMap[String(variant.id)];
    if (!specs) return;
    var strip = document.getElementById('buy-specs');
    if (!strip) return;

    var storageItem = strip.querySelector('[data-spec="storage"]');
    if (storageItem) {
      if (specs.storage_type) {
        storageItem.style.display = '';
        var icon = storageItem.querySelector('i');
        if (icon) {
          icon.className = 'ph ' + (specs.storage_type === 'Mobile phone' ? 'ph-device-mobile' : 'ph-laptop');
        }
        var label = storageItem.querySelector('[data-spec-label]');
        if (label) label.textContent = specs.storage_type;
        var val = storageItem.querySelector('[data-spec-value]');
        if (val) val.textContent = specs.storage_size;
      } else {
        storageItem.style.display = 'none';
      }
    }

    var volumeItem = strip.querySelector('[data-spec="volume"]');
    if (volumeItem) {
      var vVal = volumeItem.querySelector('[data-spec-value]');
      if (vVal) vVal.textContent = specs.volume;
      volumeItem.style.display = specs.volume ? '' : 'none';
    }

    var weightItem = strip.querySelector('[data-spec="weight"]');
    if (weightItem) {
      var wVal = weightItem.querySelector('[data-spec-value]');
      if (wVal) wVal.textContent = specs.weight;
      weightItem.style.display = specs.weight ? '' : 'none';
    }

    var specTable = document.querySelector('.acc-specs-table');
    if (specTable) {
      var tDimensions = specTable.querySelector('[data-spec-table="dimensions"]');
      if (tDimensions) {
        tDimensions.textContent = specs.dimensions || '-';
        tDimensions.closest('tr').style.display = specs.dimensions ? '' : 'none';
      }
      var tVolume = specTable.querySelector('[data-spec-table="volume"]');
      if (tVolume) {
        tVolume.textContent = specs.volume || '-';
        tVolume.closest('tr').style.display = specs.volume ? '' : 'none';
      }
      var tWeight = specTable.querySelector('[data-spec-table="weight"]');
      if (tWeight) {
        tWeight.textContent = specs.weight || '-';
        tWeight.closest('tr').style.display = specs.weight ? '' : 'none';
      }
    }

    var dimImgWrap = document.getElementById('acc-dim-image');
    if (dimImgWrap) {
      if (specs.dimensions_image) {
        dimImgWrap.innerHTML = '<img src="' + specs.dimensions_image + '" alt="Product dimensions" class="acc-dim-img" loading="lazy">';
        dimImgWrap.style.display = '';
      } else {
        dimImgWrap.style.display = 'none';
      }
    }

    var sizeFitSub = document.querySelector('[data-size-fit-subtitle]');
    if (sizeFitSub && specs.dimensions) {
      sizeFitSub.textContent = productTitle + ' - ' + specs.dimensions;
    }
  }

  function updateLowStockBadge(variant) {
    var badge = document.getElementById('low-stock-badge');
    var text = document.getElementById('low-stock-text');
    if (!badge || !text) return;

    if (lowStockThreshold > 0 && variant.available &&
        variant.inventory_management === 'shopify' &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= lowStockThreshold) {
      text.textContent = I18N.lowStock.replace('{count}', variant.inventory_quantity);
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  /* ── Variant gallery swap ──
     A colour or size tap renders sections/pdp-gallery.liquid for the new variant
     (snippets/pdp-gallery.liquid, the same markup this section renders on load,
     and nothing else - about 9 KB instead of this whole section, 65-150 KB on a
     Lotus Infinity product) and swaps in its slides and thumbs. The current
     photos stay up until the new first photo has decoded (capped at
     GALLERY_DECODE_WAIT, after which the per-slide shimmer covers the rest), so
     the gallery never goes blank.
     - The sections that follow the variant (size & fit, see it in action) load
       their render through window.pdpVariantSections below, so they share this
       cache and the hover/touch prefetch. Each piece is its own ?section_id=
       request, in parallel: one combined ?sections= request was measured slower
       (about 600 ms vs 300 ms until the gallery is in, on theme dev, 2026-10).
     - gallerySeq: only the newest tap may swap. A slow response for an earlier
       tap is dropped, so the gallery always matches the selected swatch.
     - galleryCache / sectionCache: one request per variant (and section) for the
       life of the page, also shared with the prefetch. galleryCache holds the
       extracted markup. The requests stay cache: 'no-store' (an HTTP-cached
       render once served stale image URLs after a relaunch, 812a001); a failed
       request is dropped from its cache so the next tap retries. */
  var GALLERY_DECODE_WAIT = 800;
  var GALLERY_SECTION = 'pdp-gallery';
  var gallerySeq = 0;
  var galleryCache = new Map();
  var sectionCache = new Map();

  function sectionUrl(variantId, sectionId) {
    return productUrl + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
  }

  function cachedRender(cache, key, url, parse) {
    var cached = cache.get(key);
    if (cached) return cached;
    var request = fetch(url, { cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('Section request failed: ' + r.status);
      return r.text();
    });
    if (parse) request = request.then(parse);
    cache.set(key, request);
    request.catch(function () {
      if (cache.get(key) === request) cache.delete(key);
    });
    return request;
  }

  function parseGallery(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGallery = doc.getElementById('pdp-gallery');
    if (!newGallery) throw new Error('Gallery missing from section render');
    var newThumbs = doc.querySelector('.pdp-thumb-rail');
    var hero = newGallery.querySelector('[data-gallery-idx="0"] .gallery-img');
    return {
      gallery: newGallery.innerHTML,
      thumbs: newThumbs ? newThumbs.innerHTML : null,
      hero: hero ? {
        src: hero.getAttribute('src'),
        srcset: hero.getAttribute('srcset'),
        sizes: hero.getAttribute('sizes')
      } : null
    };
  }

  function loadGallery(variantId) {
    var key = String(variantId);
    return cachedRender(galleryCache, key, sectionUrl(key, GALLERY_SECTION), parseGallery);
  }

  /* For the variant-following sections: resolves with section `sectionId`'s
     HTML for the variant (rejects if the request fails). */
  function loadVariantSection(variantId, sectionId) {
    var key = String(variantId);
    return cachedRender(sectionCache, key + ' ' + sectionId, sectionUrl(key, sectionId));
  }

  window.pdpVariantSections = { load: loadVariantSection };

  /* Bundle picker entry point (snippets/bundle-configurator.liquid): selects a variant
     by id with the same updates a swatch or size tap makes. */
  window.pdpSelectVariant = function (variantId) {
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === variantId) { variant = variants[i]; break; }
    }
    if (!variant) return;
    updateUI(variant);
    fetchGallery(variant.id);
    document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variantId: variant.id } }));
  };

  /* Prefetch: the gallery plus every section that marks its root with
     data-pdp-variant-section (and carries its data-section-id). */
  function prefetchVariant(variantId) {
    loadGallery(variantId).catch(function () {});
    document.querySelectorAll('[data-pdp-variant-section][data-section-id]').forEach(function (el) {
      loadVariantSection(variantId, el.dataset.sectionId).catch(function () {});
    });
  }

  /* Resolves true once the new first photo is decoded, false if that takes
     longer than GALLERY_DECODE_WAIT (or the first slide is a video). Same
     srcset and sizes as the slide, so the slide picks the same file from the
     memory cache. */
  function heroReady(hero) {
    if (!hero || !hero.src) return Promise.resolve(false);
    var img = new Image();
    img.fetchPriority = 'high';
    if (hero.sizes) img.sizes = hero.sizes;
    if (hero.srcset) img.srcset = hero.srcset;
    img.src = hero.src;
    var decoded = typeof img.decode === 'function'
      ? img.decode().then(function () { return true; }, function () { return false; })
      : new Promise(function (resolve) {
          img.onload = function () { resolve(true); };
          img.onerror = function () { resolve(false); };
        });
    var timeout = new Promise(function (resolve) {
      setTimeout(function () { resolve(false); }, GALLERY_DECODE_WAIT);
    });
    return Promise.race([decoded, timeout]);
  }

  function swapGallery(data, heroDecoded) {
    pauseAllVideos();
    gallery.innerHTML = data.gallery;
    if (data.thumbs !== null && thumbRail) thumbRail.innerHTML = data.thumbs;
    /* Already decoded off-DOM: let revealMedia() skip the shimmer for it. */
    if (heroDecoded) {
      var heroImg = gallery.querySelector('[data-gallery-idx="0"] .gallery-img');
      if (heroImg) heroImg.dataset.decoded = '1';
    }
    gallery.scrollTo({ left: 0 });
    initThumbnails();
    initVideoPlayers();
    setActiveMedia(0);
    warmNextForTouch();
  }

  function fetchGallery(variantId) {
    if (!gallery) return;
    var seq = ++gallerySeq;
    gallery.setAttribute('aria-busy', 'true');
    loadGallery(variantId)
      .then(function (data) {
        if (seq !== gallerySeq) return;
        return heroReady(data.hero).then(function (heroDecoded) {
          if (seq === gallerySeq) swapGallery(data, heroDecoded);
        });
      })
      .catch(function () {
        /* Keep the current photos; the next tap retries. */
      })
      .then(function () {
        if (seq === gallerySeq) gallery.removeAttribute('aria-busy');
      });
  }

  function updateSizeAvailability(color) {
    var sizeBtns = document.querySelectorAll('.size-btn');
    sizeBtns.forEach(function (btn) {
      var size = btn.dataset.size;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (hasColorOption) {
          if (optValue(variants[i], colorPos) === color && optValue(variants[i], sizePos) === size) {
            match = variants[i]; break;
          }
        } else {
          if (optValue(variants[i], sizePos) === size) {
            match = variants[i]; break;
          }
        }
      }
      if (!match) {
        btn.classList.add('is-unavailable');
        btn.classList.remove('is-hidden', 'is-active', 'is-sold-out');
        btn.setAttribute('aria-disabled', 'true');
      } else if (!match.available) {
        btn.classList.remove('is-hidden', 'is-unavailable');
        btn.classList.add('is-sold-out');
        // aria-disabled, not disabled: the button still responds to a click and shows
        // the sold-out buy state. It announces unbuyable without becoming unreachable.
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.classList.remove('is-hidden', 'is-unavailable', 'is-sold-out');
        btn.removeAttribute('aria-disabled');
      }
    });

    var oosLabel = document.getElementById('size-oos-label');
    if (oosLabel) {
      var oosCount = document.querySelectorAll('.size-btn.is-sold-out').length;
      if (oosCount > 0) {
        oosLabel.textContent = oosCount === 1
          ? I18N.sizesOosOne
          : I18N.sizesOosOther.replace('{count}', oosCount);
        oosLabel.style.display = '';
      } else {
        oosLabel.style.display = 'none';
      }
    }
  }

  function getActiveColor() {
    var active = document.querySelector('.swatch-btn.is-active');
    return active ? active.dataset.color : null;
  }

  function getActiveSize() {
    var active = document.querySelector('.size-btn.is-active');
    return active ? active.dataset.size : null;
  }

  // Prefer a size that can actually be bought. Falling back to the first existing size
  // keeps a colour whose every size is sold out from ending up with no selection at all -
  // the shopper still sees which sizes exist and gets the sold-out buy state.
  function selectFirstAvailableSize() {
    var sizeBtns = document.querySelectorAll('.size-btn');
    var fallback = null;
    for (var i = 0; i < sizeBtns.length; i++) {
      if (sizeBtns[i].classList.contains('is-hidden') || sizeBtns[i].classList.contains('is-unavailable')) continue;
      if (!fallback) fallback = sizeBtns[i];
      if (!sizeBtns[i].classList.contains('is-sold-out')) {
        sizeBtns[i].classList.add('is-active');
        return sizeBtns[i].dataset.size;
      }
    }
    if (fallback) {
      fallback.classList.add('is-active');
      return fallback.dataset.size;
    }
    return null;
  }

  // The size the shopper actually chose. Survives a detour through a colour that lacks
  // it, so Amber Mini -> Petrol (no Mini) -> Amber lands back on Mini, not on whatever
  // Petrol had. Set from the initial render once URL init has run, below.
  var preferredSize = null;
  var unavailableNote = document.getElementById('size-unavailable-note');
  var buyExpress = document.querySelector('.buy-express');

  function clearNeedsSize() {
    if (unavailableNote) { unavailableNote.hidden = true; unavailableNote.textContent = ''; }
    if (buyExpress) buyExpress.hidden = false;
    if (atcSection) atcSection.classList.remove('is-needs-size');
  }

  // The chosen size does not exist in the new colour. Never substitute another size:
  // that is how a Mini order arrived as a Medium. Leave no size selected, block every
  // buy path (ATC, sticky ATC and the express buttons, which read the form's variant
  // id directly) until the shopper picks one, and say why.
  function enterNeedsSize(color, size) {
    // No real choice yet, so no notify form either - "Select a size" must stay visible,
    // and the app's form (drawn for the stand-in variant) is hidden until a size is picked.
    bisSoldOut = false;
    applyNotifyState();
    if (atcSection) atcSection.classList.add('is-needs-size');
    if (atcBtn) {
      atcBtn.disabled = true;
      setAtcLabel(atcBtn, I18N.selectSize);
    }
    var stickyAtcBtn = document.getElementById('sticky-bar-atc');
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = true;
      setAtcLabel(stickyAtcBtn, I18N.selectSize);
    }
    if (buyExpress) buyExpress.hidden = true;
    // Stock notes and the preorder box describe the stand-in variant, not a choice.
    var badge = document.getElementById('low-stock-badge');
    if (badge) badge.style.display = 'none';
    var preorderEl = document.getElementById('buy-preorder');
    if (preorderEl) preorderEl.style.display = 'none';
    updateStockAlt(null);
    if (unavailableNote) {
      unavailableNote.textContent = I18N.sizeNotInColor.replace('{size}', size).replace('{color}', color);
      unavailableNote.hidden = false;
    }
  }

  /* Color swatch clicks */
  document.querySelectorAll('.swatch-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-active')) return;

      document.querySelectorAll('.swatch-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      var newColor = btn.dataset.color;
      var colorName = document.querySelector('.buy-color-name');
      if (colorName) colorName.textContent = newColor;
      updateSizeAvailability(newColor);

      var needsSize = false;
      var size = null;
      if (hasSizeOption && preferredSize) {
        var preferredBtn = null;
        document.querySelectorAll('.size-btn').forEach(function (b) {
          if (b.dataset.size === preferredSize) preferredBtn = b;
        });
        if (preferredBtn && !preferredBtn.classList.contains('is-unavailable')) {
          document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
          preferredBtn.classList.add('is-active');
          size = preferredSize;
        } else if (preferredBtn) {
          document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('is-active'); });
          needsSize = true;
        }
      }
      if (!size && !needsSize) size = getActiveSize() || selectFirstAvailableSize();

      var variant = needsSize ? null : findVariant(newColor, size);
      if (!variant) {
        for (var i = 0; i < variants.length; i++) {
          if (optValue(variants[i], colorPos) === newColor) { variant = variants[i]; break; }
        }
      }

      // needsSize: the variant is only a stand-in for this colour's price and gallery.
      // The size-aware sections (size & fit, see it in action) keep the chosen size.
      updateUI(variant);
      if (needsSize) enterNeedsSize(newColor, preferredSize);
      else clearNeedsSize();
      var vid = variant ? variant.id : variants[0].id;
      fetchGallery(vid);
      if (!needsSize) document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variantId: vid } }));
      document.dispatchEvent(new CustomEvent('pdp:color-change', { detail: { color: newColor } }));
    });
  });

  /* Size button clicks */
  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-hidden') || btn.classList.contains('is-unavailable')) return;

      document.querySelectorAll('.size-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      preferredSize = btn.dataset.size;
      clearNeedsSize();

      var color = getActiveColor();
      var variant = findVariant(color, btn.dataset.size);
      updateUI(variant);
      if (variant && hasSizeOption) fetchGallery(variant.id);
      if (variant) document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variantId: variant.id } }));
      document.dispatchEvent(new CustomEvent('pdp:size-change', { detail: { size: btn.dataset.size } }));
    });
  });

  /* Intent prefetch: start the gallery request for the variant a swatch or size
     tap would select as soon as the shopper signals intent - at once on touch,
     after a short hover or keyboard-focus dwell so sweeping the pointer or Tab
     across the row does not request every colour. The responses (gallery plus
     the size & fit / see it in action renders) land in galleryCache and
     sectionCache, which the tap then reuses (or a later tap, for free). Skipped
     on Save-Data and 2G. */
  var GALLERY_INTENT_DELAY = 100;
  var conn = navigator.connection;
  var galleryPrefetchOff = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));

  // The variant a swatch tap will show the gallery of - mirrors the swatch
  // click handler: the chosen size if this colour has it, else this colour's
  // stand-in (first variant), and with no size chosen yet its first buyable one.
  function galleryVariantForColor(color) {
    var size = hasSizeOption ? (preferredSize || getActiveSize()) : null;
    if (size) return findVariant(color, size) || findVariant(color, null);
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      if (optValue(variants[i], colorPos) !== color) continue;
      if (variants[i].available) return variants[i];
      if (!first) first = variants[i];
    }
    return first;
  }

  function prefetchGalleryFor(btn) {
    if (btn.classList.contains('is-active')) return;
    var variant = null;
    if (btn.classList.contains('swatch-btn')) {
      variant = galleryVariantForColor(btn.dataset.color);
    } else if (hasSizeOption && !btn.classList.contains('is-hidden') && !btn.classList.contains('is-unavailable')) {
      variant = findVariant(getActiveColor(), btn.dataset.size);
    }
    if (variant) prefetchVariant(variant.id);
  }

  if (gallery && !galleryPrefetchOff) {
    document.querySelectorAll('.swatch-btn, .size-btn').forEach(function (btn) {
      var timer = null;
      function soon() {
        clearTimeout(timer);
        timer = setTimeout(function () { prefetchGalleryFor(btn); }, GALLERY_INTENT_DELAY);
      }
      function cancel() { clearTimeout(timer); }
      btn.addEventListener('touchstart', function () { prefetchGalleryFor(btn); }, { passive: true });
      btn.addEventListener('pointerenter', function (e) {
        // A touch already prefetched on touchstart.
        if (e.pointerType !== 'touch') soon();
      }, { passive: true });
      btn.addEventListener('pointerleave', cancel, { passive: true });
      btn.addEventListener('focus', soon);
      btn.addEventListener('blur', cancel);
    });
  }

  /* URL init */
  var params = new URLSearchParams(window.location.search);
  var urlVariantId = params.get('variant');

  var liquidRenderedColor = getActiveColor();

  if (urlVariantId) {
    var target = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === urlVariantId) { target = variants[i]; break; }
    }
    // Liquid already refused to select a not-released colour, so its swatch does not
    // exist in the DOM. Dropping the target here keeps the JS from re-selecting it and,
    // critically, from reaching the reveal below - that reveal exists for sold-out
    // colours, which are hidden but legitimate. An unreleased colour must stay gone.
    // Gated on hasColorOption, not on swatch presence: a fully-blocked product (every
    // colour not-released) also renders zero .swatch-btn elements, and testing for
    // "no swatches in the DOM" would misread that as "no Color option at all" and wave
    // a ?variant= link straight through, re-enabling the buy button the Liquid render
    // just disabled.
    if (target) {
      var targetSwatchExists = !hasColorOption ||
        [...document.querySelectorAll('.swatch-btn')].some(function (b) {
          return b.dataset.color === optValue(target, colorPos);
        });
      if (!targetSwatchExists) target = null;
    }

    if (target) {
      var targetColor = optValue(target, colorPos);
      var targetSize = optValue(target, sizePos);

      document.querySelectorAll('.swatch-btn').forEach(function (b) {
        var match = b.dataset.color === targetColor;
        // A ?variant= link (ad, mail, Shopping feed) can point straight at a sold-out
        // colour, whose swatch Liquid hid. Reveal that one - landing on a PDP with no
        // selected colour is worse than showing it struck through. It keeps .is-sold-out.
        if (match) b.classList.remove('is-hidden');
        b.classList.toggle('is-active', match);
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
      if (targetSize) {
        document.querySelectorAll('.size-btn').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.size === targetSize);
        });
      }

      updateUI(target);

      if (liquidRenderedColor !== targetColor) {
        fetchGallery(target.id);
      }
    }
  }

  var initColor = getActiveColor();
  if (initColor) updateSizeAvailability(initColor);
  preferredSize = getActiveSize();

  /* Sync dependent sections (bundle, pairs-well-with, comparison) to the initial
     variant. Deferred so their pdp:* listeners are registered before we dispatch. */
  setTimeout(function () {
    var ic = getActiveColor();
    var is = getActiveSize();
    if (ic) document.dispatchEvent(new CustomEvent('pdp:color-change', { detail: { color: ic } }));
    if (is) document.dispatchEvent(new CustomEvent('pdp:size-change', { detail: { size: is } }));
  }, 0);

  /* ── Image Zoom ── */
  var zoomOverlay = document.getElementById('zoom-overlay');
  var zoomImg = document.getElementById('zoom-img');
  var zoomClose = document.getElementById('zoom-close');

  function openZoom(src, alt) {
    if (!zoomOverlay || !zoomImg) return;
    document.body.appendChild(zoomOverlay);
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    zoomOverlay.classList.add('is-open');
    zoomOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeZoom() {
    if (!zoomOverlay) return;
    zoomOverlay.classList.remove('is-open');
    zoomOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.gallery-video-wrap')) return;
    var img = e.target.closest('.gallery-img');
    if (img) {
      var src = img.currentSrc || img.src;
      openZoom(src, img.alt);
    }
  });

  if (zoomClose) zoomClose.addEventListener('click', closeZoom);

  if (zoomOverlay) {
    zoomOverlay.addEventListener('click', function (e) {
      if (e.target === zoomOverlay) closeZoom();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoom();
  });
})();

/* Sticky add-to-cart bar */
(function () {
  var atcSection = document.getElementById('atc-section');
  var stickyBar = document.getElementById('sticky-bar');
  if (!atcSection || !stickyBar) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // Only show once the ATC has scrolled off the top (user passed it),
      // not while it's still below the fold and never been seen.
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('visible', scrolledPast);
    });
  }, { threshold: 0 });

  observer.observe(atcSection);
})();

  /* ---- Second-item offer ---------------------------------------------------
     Layout and controls are the theme's own (.pdp-bundle--compact, the shared
     drawer, .swatch-btn / .size-btn). This only wires them
     together: the drawer composes BOTH products, then a single /cart/add posts
     the pair so the qualifying combination -- and therefore the admin automatic
     discount -- lands in one go. Two requests would briefly render an
     undiscounted cart, which reads as a broken promise.

     No money arithmetic happens here. Every price string is pre-rendered by
     Liquid through `| money` and looked up, per the PDP currency fix. */
  (function () {
    var row = document.querySelector('[data-second-item-offer]');
    if (!row) return;

    var drawerId = row.getAttribute('data-sio-drawer');
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;

    var addBtn = drawer.querySelector('[data-sio-add]');
    var addLabelEl = addBtn ? addBtn.querySelector('span') : null;
    if (!addBtn || !addLabelEl) return;
    var addLabel = addLabelEl.textContent;
    var soldOut = row.getAttribute('data-sio-soldout') || 'Sold out';

    /* Analytics. GA runs inside Shopify's sandboxed web pixels, which cannot see
       the page, so the offer publishes Shopify custom events and a custom pixel
       (Settings > Customer events) forwards them to GA4. Three steps of one
       funnel: seen, drawer opened, pair added. The purchase step needs nothing
       here - it is the automatic discount's title on checkout_completed. */
    var sioData = {};
    try { sioData = JSON.parse(row.getAttribute('data-sio-analytics')) || {}; } catch (err) {}

    function track(name, extra) {
      var a = window.Shopify && window.Shopify.analytics;
      if (!a || typeof a.publish !== 'function') return;
      var payload = {};
      Object.keys(sioData).forEach(function (k) { payload[k] = sioData[k]; });
      Object.keys(extra || {}).forEach(function (k) { payload[k] = extra[k]; });
      try { a.publish(name, payload); } catch (err) {}
    }

    /* "Seen" means half the row on screen, once per page view, so a shopper who
       never scrolls to it does not dilute the open rate. */
    if ('IntersectionObserver' in window) {
      var seenIo = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        seenIo.disconnect();
        track('ucon:second_item_offer_viewed');
      }, { threshold: 0.5 });
      seenIo.observe(row);
    }

    row.querySelectorAll('[data-sio-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.__openDrawer(drawerId);
        track('ucon:second_item_offer_opened');
      });
    });

    /* One controller per product, so host and partner behave identically. */
    var products = [].map.call(drawer.querySelectorAll('.sio-drawer__product'), function (el) {
      var map = {};
      var json = el.querySelector('[data-sio-variants]');
      try { map = JSON.parse(json.textContent); } catch (err) {}
      var role = el.getAttribute('data-sio-role');
      return { el: el, role: role, map: map, rowCard: row.querySelector('[data-sio-item="' + role + '"]') };
    });

    /* Each variant carries its price display pre-rendered by Liquid through
       snippets/price.liquid (the reward product's at the offer price - the
       partner, or the host on a reward page - the other's with any compare-at
       sale), so nothing here formats currency or builds markup. */
    function setPrices(scope, entry) {
      if (!scope || !entry.priceHtml) return;
      scope.querySelectorAll('[data-sio-price]').forEach(function (n) { n.innerHTML = entry.priceHtml; });
    }

    function chosen(p, sel, attr) {
      var el = p.el.querySelector(sel + '.is-active');
      return el ? el.getAttribute(attr) : '';
    }

    function entryFor(p) {
      return p.map[chosen(p, '.sio-swatch-btn', 'data-sio-color') + '|' + chosen(p, '.sio-size-btn', 'data-sio-size')];
    }

    function refreshAddState() {
      var usable = products.map(entryFor).every(function (e) { return e && e.available; });
      addBtn.disabled = !usable;
      addLabelEl.textContent = usable ? addLabel : soldOut;
    }

    function sync(p) {
      var colour = chosen(p, '.sio-swatch-btn', 'data-sio-color');

      /* Grey out the sizes this colour does not come in, so an impossible
         combination is visible before the shopper presses the button. */
      p.el.querySelectorAll('.sio-size-btn').forEach(function (b) {
        var e = p.map[colour + '|' + b.getAttribute('data-sio-size')];
        b.disabled = !e;
        b.classList.toggle('is-unavailable', !e || !e.available);
      });

      var entry = entryFor(p);
      if (entry) {
        var img = p.el.querySelector('.sio-drawer__img');
        if (img && entry.image) { img.src = entry.image; img.removeAttribute('srcset'); }
        setPrices(p.el, entry);

        /* Mirror the choice back onto the row behind the drawer. */
        if (p.rowCard) {
          var rowImg = p.rowCard.querySelector('.pdp-bundle__photo');
          if (rowImg && entry.image) { rowImg.src = entry.image; rowImg.removeAttribute('srcset'); }
          setPrices(p.rowCard, entry);
          var sub = p.rowCard.querySelector('[data-sio-subline]');
          if (sub) {
            var series = sub.getAttribute('data-sio-series') || '';
            sub.textContent = series && entry.size ? series + ' - ' + entry.size : (series || entry.size || '');
          }
        }
      }
      refreshAddState();
    }

    function select(p, group, btn) {
      if (!btn || btn.disabled) return false;
      p.el.querySelectorAll(group).forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      sync(p);
      return true;
    }

    /* Match on the attribute rather than building a selector: colour names carry
       spaces and hyphens, and quoting them into an attribute selector is a
       needless escaping hazard. */
    function byAttr(scope, sel, attr, val) {
      var found = null;
      scope.querySelectorAll(sel).forEach(function (b) {
        if (!found && b.getAttribute(attr) === val) found = b;
      });
      return found;
    }

    /* Drive the PDP's own colour and size buttons rather than reimplementing
       variant selection. Clicking them runs the gallery, price, form-variant and
       stock logic that already exists, so the page and the cart cannot disagree
       about which host variant is being bought. */
    function drivePdp(colour, size) {
      var c = byAttr(document, '.swatch-btn[data-color]', 'data-color', colour);
      if (c && !c.classList.contains('is-active')) c.click();
      var z = byAttr(document, '.size-btn[data-size]', 'data-size', size);
      if (z && !z.classList.contains('is-active')) z.click();
    }

    /* Follow the host's colour on the partner when that colour exists there,
       otherwise leave the shopper's pick alone. Colour names are shared across
       series but not universally - Hajo Original's "Dark Sand - Light Sand" has
       no Jona equivalent - so this matches when it can and never hides the
       offer when it cannot. */
    /* The automatic match must land on something buyable. A colour whose sizes
       are all sold out is not matched at all, and when the selected size is
       missing OR sold out in the matched colour, the first in-stock size is
       taken instead - otherwise the row advertises e.g. a sold-out Medium while
       the Large of the same colour is in stock. This only applies to the
       automatic match; a shopper's own pick is never moved. */
    function firstInStockSize(p, colour) {
      var sizes = p.el.querySelectorAll('.sio-size-btn');
      for (var i = 0; i < sizes.length; i++) {
        var e = p.map[colour + '|' + sizes[i].getAttribute('data-sio-size')];
        if (e && e.available) return sizes[i];
      }
      return null;
    }

    function matchPartner(colour) {
      if (!colour) return;
      products.forEach(function (p) {
        if (p.role !== 'partner') return;
        var btn = byAttr(p.el, '.sio-swatch-btn', 'data-sio-color', colour);
        if (!btn) return;
        /* No size row (an Alva, a Motif 2.0 bag): the colour alone is the variant. */
        if (!p.el.querySelector('.sio-size-btn')) {
          var only = p.map[colour + '|'];
          if (only && only.available && !btn.classList.contains('is-active')) select(p, '.sio-swatch-btn', btn);
          return;
        }
        if (!firstInStockSize(p, colour)) return;
        if (!btn.classList.contains('is-active')) select(p, '.sio-swatch-btn', btn);
        var entry = entryFor(p);
        if (!entry || !entry.available) select(p, '.sio-size-btn', firstInStockSize(p, colour));
      });
    }

    products.forEach(function (p) {
      p.el.querySelectorAll('.sio-swatch-btn, .sio-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var group = btn.classList.contains('sio-swatch-btn') ? '.sio-swatch-btn' : '.sio-size-btn';
          select(p, group, btn);
          if (p.role === 'host') {
            var colour = chosen(p, '.sio-swatch-btn', 'data-sio-color');
            drivePdp(colour, chosen(p, '.sio-size-btn', 'data-sio-size'));
            matchPartner(colour);
          }
        });
      });
      sync(p);
    });

    /* The PDP is the other half of the same conversation: choosing a colour or
       size on the page moves the row and the drawer with it, and the partner
       follows where it can. Deliberately does NOT call drivePdp - the PDP is
       already where it needs to be, and calling back into it would be a loop. */
    function adoptFromPdp(group, attr, value) {
      if (!value) return;
      products.forEach(function (p) {
        if (p.role !== 'host') return;
        var btn = byAttr(p.el, group, attr, value);
        if (btn && !btn.classList.contains('is-active')) select(p, group, btn);
      });
      if (group === '.sio-swatch-btn') matchPartner(value);
    }

    document.addEventListener('pdp:color-change', function (e) {
      adoptFromPdp('.sio-swatch-btn', 'data-sio-color', e.detail && e.detail.color);
    });

    document.addEventListener('pdp:size-change', function (e) {
      adoptFromPdp('.sio-size-btn', 'data-sio-size', e.detail && e.detail.size);
    });

    /* Start paired, so the row opens showing a matching set where one exists. */
    products.forEach(function (p) {
      if (p.role === 'host') matchPartner(chosen(p, '.sio-swatch-btn', 'data-sio-color'));
    });

    addBtn.addEventListener('click', function () {
      var items = products.map(entryFor);
      if (items.some(function (e) { return !e || !e.available; })) return;

      addBtn.disabled = true;
      addLabelEl.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (e) { return { id: e.id, quantity: 1 }; }),
          sections: 'cart-drawer'
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(function (data) {
          var added = {};
          products.forEach(function (p, i) { added[p.role + '_variant_id'] = items[i].id; });
          track('ucon:second_item_offer_added', added);
          if (window.UconCart && window.UconCart.tagSource) {
            window.UconCart.tagSource(items.map(function (e) { return e.id; }), 'bundle');
          }
          window.__closeDrawer(drawerId);
          var drawerHtml = data && data.sections && data.sections['cart-drawer'];
          if (window.UconCart && typeof window.UconCart.addedWithSection === 'function') {
            window.UconCart.addedWithSection(drawerHtml);
          } else {
            document.dispatchEvent(new CustomEvent('cart:added'));
          }
        })
        .catch(function () {
          addLabelEl.textContent = '!';
        })
        .then(function () {
          setTimeout(function () {
            addLabelEl.textContent = addLabel;
            addBtn.disabled = false;
          }, 1500);
        });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-np]');
    if (!root) return;

    var opts;
    try {
      opts = JSON.parse(root.getAttribute('data-options') || '{}');
    } catch (e) {
      return;
    }

    var storeKey = 'np-' + window.location.hostname + '-' + opts.sectionId;
    var WINDOWS = { day: 86400000, week: 604800000 };
    var lastFocused = null;

    function open() {
      if (root.open) return;
      lastFocused = document.activeElement;
      if (typeof root.showModal === 'function') {
        root.showModal();
      } else {
        root.setAttribute('open', '');
      }
    }

    // Automatic opens only. A cart drawer, mobile menu or search dialog is
    // already in the top layer, and showModal() would legally stack on top
    // of an interaction the visitor started themselves.
    //
    // The Geo:Pro app (EU store) asks some visitors whether to switch store. Its
    // prompt is a plain fixed div (#geoip-banner), and a modal <dialog> always
    // paints above and blocks it, so the newsletter would hide an unanswered
    // store prompt. While that prompt is on the page, wait for the app to remove
    // it (it does on Yes, No and the close icon), then open.
    var GEO_PROMPT = '#geoip-banner';

    function openIfClear() {
      if (document.querySelector('dialog[open]')) return;
      if (document.querySelector(GEO_PROMPT)) {
        if (!window.MutationObserver) return;
        var watch = new MutationObserver(function () {
          if (document.querySelector(GEO_PROMPT)) return;
          watch.disconnect();
          openIfClear();
        });
        watch.observe(document.body, { childList: true, subtree: true });
        return;
      }
      open();
    }

    // The opposite order: the newsletter is already up when Geo:Pro renders
    // (slow geo lookup, exit intent). Step aside without counting it as a
    // dismissal, and come back once the store prompt is answered. The close
    // event is async (and not guaranteed, see close()), so the flag only tells
    // the close listener to skip remember(), and the reopen does not wait on it.
    // The short wait lets Geo:Pro mount its prompt before openIfClear looks.
    var yieldingToGeo = false;

    document.addEventListener('easylocation_before_render', function () {
      if (!root.open) return;
      yieldingToGeo = true;
      if (typeof root.close === 'function') {
        root.close();
      } else {
        root.removeAttribute('open');
      }
      lastFocused = null;
      window.setTimeout(function () {
        yieldingToGeo = false;
        openIfClear();
      }, 1000);
    });

    function close() {
      if (root.open && typeof root.close === 'function') {
        root.close();
      } else {
        root.removeAttribute('open');
      }
      // Persist here as well as on the close event. The event is the only way
      // to catch a native Esc, but it does not fire on the removeAttribute
      // fallback, and some engines skip it entirely - and a missed write means
      // the frequency gate never engages and the popup nags every pageview.
      // remember() is idempotent, so running twice is harmless.
      remember();
    }

    function remember() {
      if (window.Shopify && window.Shopify.designMode) return;
      try {
        window.localStorage.setItem(
          storeKey,
          JSON.stringify({ shown: Date.now(), content: opts.content })
        );
      } catch (e) {
        /* Private mode: the dismissal just is not remembered. */
      }
    }

    // Fires for the close button, Esc and close().
    root.addEventListener('close', function () {
      if (yieldingToGeo) return;
      remember();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    });

    var closeBtn = root.querySelector('[data-np-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Clicking the ::backdrop lands on the dialog element itself.
    root.addEventListener('click', function (e) {
      if (e.target === root) close();
    });

    // The form posts to /contact#newsletter-popup-form, so this fragment means
    // our own submission came back. Show the result whatever the gates say.
    if (window.location.hash === '#' + opts.formId) {
      open();
      // A completed signup counts as a dismissal, otherwise the subscriber
      // gets prompted again on their next visit.
      if (root.querySelector('.np__success')) remember();
      return;
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === opts.sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === opts.sectionId) close();
      });
      return;
    }

    // Session gate. Storage blocked entirely means no frequency gate either,
    // so bail rather than reopen on every pageview.
    var views;
    try {
      views = parseInt(window.sessionStorage.getItem('np-views') || '0', 10) + 1;
      window.sessionStorage.setItem('np-views', String(views));
    } catch (e) {
      return;
    }
    if (opts.skipFirst && views < 2) return;

    // Frequency gate. A copy change resets everyone.
    var state = null;
    try {
      var raw = window.localStorage.getItem(storeKey);
      if (raw) state = JSON.parse(raw);
    } catch (e) {
      state = null;
    }
    if (state && state.content === opts.content) {
      if (opts.frequency === 'once') return;
      if (Date.now() - state.shown < WINDOWS[opts.frequency]) return;
    }

    var desktop = window.matchMedia('(min-width: 750px) and (pointer: fine)').matches;
    var delay = desktop ? opts.delayDesktop : opts.delayMobile;
    var timer = window.setTimeout(openIfClear, delay * 1000);

    if (desktop && opts.exitIntent) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.clientY > 0 || e.relatedTarget) return;
        window.clearTimeout(timer);
        document.removeEventListener('mouseout', onOut);
        openIfClear();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pairs-well-with"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.pw');
  if (!section) return;

  /* The recommendations only exist in the Section Rendering API response, so the
     page HTML carries an empty shell. It used to be filled when the shell came
     within 400px, and a fast scroll got there before the response did: the band
     grew from 0 to ~400px under the reader and pushed everything below it down
     (CLS 0.25-0.47 on a phone fling). Now it loads at the first of: browser idle
     after window load (as Loox reviews do), or the shell within 1500px. */
  if (section.dataset.url) {
    var pwStarted = false;
    var observer = null;

    var pwLoad = function () {
      if (pwStarted) return;
      pwStarted = true;
      if (observer) observer.disconnect();
      fetch(section.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.pw');
          if (fresh && fresh.innerHTML.trim().length) {
            section.innerHTML = fresh.innerHTML;
            initDrawers();
            pwApplyColor(pwCurrentColor());
          }
        })
        .catch(function (e) { console.error(e); });
    };

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) pwLoad();
      }, { rootMargin: '1500px 0px' });
      observer.observe(section);
    }

    var pwWhenIdle = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(pwLoad, { timeout: 2000 });
      } else {
        setTimeout(pwLoad, 200);
      }
    };

    if (document.readyState === 'complete') {
      pwWhenIdle();
    } else {
      window.addEventListener('load', pwWhenIdle, { once: true });
    }
  }

  /* Analytics: ucon:pairs_well_viewed / _opened / _added, Shopify custom events a
     custom pixel forwards to GA4 - the same funnel as the second-item offer. The
     add itself is tagged pairs-well in _atc_sources (UconCart.tagSource below). */
  function pwTrack(name, extra) {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return;
    var payload = {
      host_product_id: Number(section.dataset.hostId) || null,
      host_title: section.dataset.hostTitle || ''
    };
    Object.keys(extra || {}).forEach(function (k) { payload[k] = extra[k]; });
    try { a.publish(name, payload); } catch (err) {}
  }

  function pwCardData(id) {
    var card = pwCard(id);
    return { product_id: Number(id), product_title: card ? card.getAttribute('data-pw-title') : '' };
  }

  /* "Seen" = half the row on screen, once per page view. The row arrives with
     the recommendations, so initDrawers() starts the watch. */
  var pwSeen = false;
  var pwSeenIo = null;
  function pwWatchSeen() {
    var grid = section.querySelector('.pw__grid');
    if (pwSeen || !grid || !('IntersectionObserver' in window)) return;
    if (pwSeenIo) pwSeenIo.disconnect();
    pwSeenIo = new IntersectionObserver(function (entries) {
      if (pwSeen || !entries.some(function (e) { return e.isIntersecting; })) return;
      pwSeen = true;
      pwSeenIo.disconnect();
      var cards = section.querySelectorAll('.pw__card');
      pwTrack('ucon:pairs_well_viewed', {
        product_count: cards.length,
        product_titles: [].map.call(cards, function (c) { return c.getAttribute('data-pw-title'); }).join(' | ')
      });
    }, { threshold: 0.5 });
    pwSeenIo.observe(grid);
  }

  if (section.querySelector('.pw__grid')) {
    initDrawers();
    pwApplyColor(pwCurrentColor());
  }

  /* Card + drawer state comes from the per-colour map Liquid rendered on the
     card (data-pw-colors) - variant id, size, photo, price and compare-at
     price, money already formatted. */
  function pwData(card, attr) {
    try { return JSON.parse(card.getAttribute(attr) || 'null'); } catch (err) { return null; }
  }

  function pwCard(id) {
    return section.querySelector('.pw__card[data-pw-card="' + id + '"]');
  }

  /* The price display arrives pre-rendered through snippets/price.liquid. */
  function pwSetPrice(scope, entry) {
    if (scope && entry.priceHtml) scope.innerHTML = entry.priceHtml;
  }

  /* Paint one entry onto a card and its drawer: photo, size subline, prices,
     active swatch and the add button. */
  function pwShow(card, entry) {
    if (!card || !entry) return;
    var id = card.getAttribute('data-pw-card');

    var img = card.querySelector('.pw__photo');
    if (img && entry.img) { img.setAttribute('src', entry.img); img.removeAttribute('srcset'); }

    var sub = card.querySelector('[data-pw-subline]');
    if (sub) {
      var series = sub.getAttribute('data-pw-series') || '';
      sub.textContent = series && entry.size ? series + ' - ' + entry.size : (series || entry.size || '');
    }
    pwSetPrice(card.querySelector('.pw__price'), entry);

    var summary = section.querySelector('.pw__drawer-summary[data-pw-card="' + id + '"]');
    if (summary) {
      var dImg = summary.querySelector('.pw__drawer-img');
      if (dImg && entry.img) dImg.setAttribute('src', entry.img);
      pwSetPrice(summary.querySelector('.pw__drawer-price'), entry);
    }

    var row = section.querySelector('.pw__swatch-row[data-pw-card="' + id + '"]');
    if (row) {
      row.querySelectorAll('.pw__swatch-btn').forEach(function (s) {
        var on = s.getAttribute('data-color') === (entry.color || '').toLowerCase();
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    var atc = section.querySelector('.pw__atc[data-pw-card="' + id + '"]');
    if (atc) {
      atc.setAttribute('data-variant-id', entry.id);
      atc.disabled = !entry.available;
      var label = atc.querySelector('span');
      if (label) {
        label.textContent = entry.available
          ? (atc.getAttribute('data-label-add') || '') + entry.price
          : (atc.getAttribute('data-label-sold') || '');
      }
    }
  }

  /* Follow the host's colour only where it is in stock here; otherwise show
     the card's default (first released in-stock variant), never a sold-out
     combination. */
  function pwApplyColor(color) {
    color = (color || '').toLowerCase();
    section.querySelectorAll('.pw__card').forEach(function (card) {
      var map = pwData(card, 'data-pw-colors') || {};
      var entry = map[color];
      if (!entry || !entry.available) entry = pwData(card, 'data-pw-default');
      pwShow(card, entry);
    });
  }

  function pwCurrentColor() {
    var active = document.querySelector('.swatch-btn.is-active');
    return active ? active.dataset.color : '';
  }

  document.addEventListener('pdp:color-change', function (e) {
    pwApplyColor(e.detail.color);
  });

  function initDrawers() {
    pwWatchSeen();
    section.querySelectorAll('.pw__quick-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.__openDrawer(btn.getAttribute('data-drawer-id'));
        pwTrack('ucon:pairs_well_opened', pwCardData(btn.closest('.pw__card').getAttribute('data-pw-card')));
      });
    });

    /* A shopper's own pick is shown as-is, sold out included - the button
       then says so rather than silently swapping their colour. */
    section.querySelectorAll('.pw__swatch-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = pwCard(btn.closest('.pw__swatch-row').getAttribute('data-pw-card'));
        if (!card) return;
        var map = pwData(card, 'data-pw-colors') || {};
        pwShow(card, map[btn.getAttribute('data-color')]);
      });
    });

    section.querySelectorAll('.pw__atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.getAttribute('data-variant-id'));
        var label = btn.querySelector('span');
        var originalText = label.textContent;
        btn.disabled = true;
        /* Busy, not sold out: theme.css keeps an aria-busy button at full strength. */
        btn.setAttribute('aria-busy', 'true');
        label.textContent = 'Adding…';

        var cartUrl = section.dataset.cartAddUrl || '/cart/add';
        fetch(cartUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // Ask the add response to carry the re-rendered cart-drawer so we can
          // hand it straight to the drawer -- avoids a second fetch to refresh.
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer' })
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(function (data) {
          label.textContent = 'Added ✓';
          if (window.UconCart && window.UconCart.tagSource) {
            window.UconCart.tagSource([variantId], 'pairs-well');
          }
          pwTrack('ucon:pairs_well_added', Object.assign(pwCardData(btn.getAttribute('data-pw-card')), { variant_id: variantId }));
          // Open + refresh the global cart drawer (assets/cart.js).
          var drawerHtml = data && data.sections && data.sections['cart-drawer'];
          if (window.UconCart && typeof window.UconCart.addedWithSection === 'function') {
            window.UconCart.addedWithSection(drawerHtml);
          } else {
            document.dispatchEvent(new CustomEvent('cart:added'));
          }
          setTimeout(function () {
            label.textContent = originalText;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }, 1500);
        })
        .catch(function () {
          label.textContent = 'Error';
          setTimeout(function () {
            label.textContent = originalText;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }, 1500);
        });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  if (window.__searchResultsInit) return;
  window.__searchResultsInit = true;

  function sectionEl() {
    return document.querySelector('.search[data-section-id]');
  }

  // Keep the sticky filter bar below the header group; re-run after swaps.
  function setStickyOffset() {
    var bar = document.querySelector('.search .filter-bar');
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (bar && headerGroup) bar.style.top = headerGroup.offsetHeight + 'px';
  }

  // A single persistent live region appended to <body> so it survives the
  // section swap. The visible title is NOT a live region (it lives inside the
  // swapped node); instead we mirror its text here once per swap.
  function liveRegion() {
    var node = document.getElementById('search-live-region');
    if (!node) {
      node = document.createElement('p');
      node.id = 'search-live-region';
      node.className = 'visually-hidden';
      node.setAttribute('aria-live', 'polite');
      node.setAttribute('role', 'status');
      document.body.appendChild(node);
    }
    return node;
  }

  function announceAndFocus(section) {
    var count = section.querySelector('[data-search-count]');
    if (!count) return;
    var text = count.textContent.trim();
    var region = liveRegion();
    region.textContent = '';
    window.setTimeout(function () { region.textContent = text; }, 50);
    count.focus();
  }

  // Only the newest tap may land - same guard as the collection filter bar
  // (sections/collection-filter-bar.liquid): a newer navigate() aborts the one in
  // flight, so a slow earlier answer can't swap in and push a filter the customer
  // already moved away from, and a sort change builds on the pending filter.
  var inflight = null;
  var inflightUrl = null;

  // Swap the search section in place via the Section Rendering API; fall back
  // to a full navigation if anything is missing or the request fails.
  function navigate(url, push) {
    var section = sectionEl();
    var id = section ? section.getAttribute('data-section-id') : null;
    if (!id) { window.location.href = url; return; }

    var dest = new URL(url, window.location.origin);
    var fetchUrl = new URL(dest.toString());
    fetchUrl.searchParams.set('sections', id);

    section.classList.add('is-loading');

    if (inflight) inflight.abort();
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    inflight = ctl;
    inflightUrl = dest.toString();
    function superseded() { return !!(ctl && ctl.signal.aborted); }

    fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('Bad response');
        return r.json();
      })
      .then(function (json) {
        if (superseded()) return;
        if (inflight === ctl) { inflight = null; inflightUrl = null; }
        if (json[id] == null) throw new Error('Missing section');
        var target = document.getElementById('shopify-section-' + id);
        if (!target) throw new Error('No section node');
        var parser = new DOMParser();
        var doc = parser.parseFromString(json[id], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        if (push !== false) history.pushState({ search: true }, '', dest.toString());
        setStickyOffset();
        announceAndFocus(target);
        // The grid is back to page 1 under this URL - drop any run recorded
        // against it, or Back from a product would rebuild pages the customer
        // no longer had open. After the pushState: the key comes from location.
        if (window.colGridPagination) window.colGridPagination.reset();
      })
      .catch(function (err) {
        // Aborted by a newer tap, which owns the page now - no full-load fallback.
        if (superseded() || (err && err.name === 'AbortError')) return;
        if (inflight === ctl) { inflight = null; inflightUrl = null; }
        window.location.href = url;
      });
  }
  // Exposed so the shared filters block's mobile drawer "Apply" can swap too.
  window.__collectionFilterNavigate = navigate;

  // Desktop filter links (dropdown options, clear) + applied pills -> AJAX swap.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    if (!link.closest('.filters-desktop') && !link.closest('.filter-bar__applied')) return;
    if (link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    e.preventDefault();
    navigate(href, true);
  });

  // Sort change -> AJAX swap.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.filter-bar__sort-select');
    if (!sel) return;
    var url = new URL(inflightUrl || window.location.href);
    url.searchParams.set('sort_by', sel.value);
    navigate(url.toString(), true);
  });

  // Load more is not handled here: it lives in assets/col-grid-pagination.js,
  // shared with the collection grid. This page wraps its results in .col-grid,
  // which is all that file needs to take over - appending pages, and rebuilding
  // them when a customer comes back from a product.

  window.addEventListener('popstate', function () {
    if (sectionEl()) navigate(window.location.href, false);
  });

  window.addEventListener('resize', setStickyOffset);
  setStickyOffset();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  /* Tile UI only: a click toggles play/pause and the overlay button mirrors the video's
     state. Autoplay tiles are started elsewhere - <video data-autoplay-in-view> is picked
     up by assets/video-in-view.js (timing rules in its header: it starts a clip as the
     visitor is about to reach it, and the next tile in this row as a swipe brings it in),
     and never autoplays under reduced motion or Save-Data. So the button follows the media
     events, whoever started or paused the clip. */
  function initVideoWrap(wrap) {
    if (wrap.dataset.videoInit) return;
    wrap.dataset.videoInit = '1';

    var video = wrap.querySelector('video');
    var btn = wrap.querySelector('.pdp-videos__play');
    if (!video || !btn) return;
    var icon = btn.querySelector('i');

    function showPlaying() {
      btn.style.opacity = '0';
      icon.className = 'ph ph-pause-circle';
    }

    function showPaused() {
      btn.style.opacity = '1';
      icon.className = 'ph ph-play-circle';
    }

    /* `moving`: the clip has shown frames since it last paused or was unloaded. Until then a
       started-but-buffering clip still shows its cover and play button, so a tap on it means
       "play", not "pause". */
    var moving = false;

    /* Real frames are on screen: retire the cover image and the play button. */
    function markStarted() {
      moving = true;
      wrap.classList.add('is-started');
      showPlaying();
    }

    video.addEventListener('pause', function () {
      moving = false;
      showPaused();
    });
    video.addEventListener('playing', markStarted);
    /* video-in-view.js unloads a clip it should not keep downloading: its frame is gone, so
       the cover comes back until the next start. */
    video.addEventListener('emptied', function () {
      moving = false;
      wrap.classList.remove('is-started');
      showPaused();
    });

    /* In case the observer got to this clip first. */
    if (!video.paused && video.readyState > 2) markStarted();

    /* The tap acts on what the visitor saw when the finger went down: a clip that starts
       moving between pointerdown and click must not turn a "play" tap into a pause. */
    var movingAtPress = null;
    wrap.addEventListener('pointerdown', function () {
      movingAtPress = moving;
    });

    wrap.addEventListener('click', function () {
      var wasMoving = movingAtPress === null ? moving : movingAtPress;
      movingAtPress = null;
      if (!wasMoving) {
        /* data-user-played: the visitor started it, so video-in-view.js does not pause it
           for timing reasons, only once it is off screen. */
        video.removeAttribute('data-user-paused');
        video.setAttribute('data-user-played', '');
        /* An unloaded autoplay clip has no sources until they are put back. */
        if (window.videoInView && window.videoInView.restore) window.videoInView.restore(video);
        var played = video.play();
        if (played && played.catch) played.catch(showPaused);
      } else {
        /* Tells video-in-view.js not to restart it the next time it scrolls past. */
        video.removeAttribute('data-user-played');
        video.setAttribute('data-user-paused', '');
        video.pause();
      }
    });

    wrap.addEventListener('mouseenter', function () {
      if (moving) btn.style.opacity = '0.7';
    });

    wrap.addEventListener('mouseleave', function () {
      if (moving) btn.style.opacity = '0';
    });
  }

  function initVideos(root) {
    (root || document).querySelectorAll('.pdp-videos__wrap[data-video-wrap]').forEach(initVideoWrap);
  }

  initVideos(document);

  /* Theme editor: a re-rendered section brings tiles nothing is bound to yet. */
  document.addEventListener('shopify:section:load', function (e) {
    initVideos(e.target);
  });

  // Size-aware swap: on variant change, take this section's render for the
  // selected variant (Section Rendering API) and replace the grid with the
  // size-matched features. Mirrors sections/size-and-fit.liquid: on the PDP the
  // render comes through main-product's per-variant cache
  // (window.pdpVariantSections), already warmed by the swatch/size hover and
  // touch prefetch (data-pdp-variant-section on the root opts in); without
  // main-product on the page it fetches the render itself.
  function loadVideosRender(productUrl, sectionId, variantId) {
    var shared = window.pdpVariantSections;
    if (shared && typeof shared.load === 'function') return shared.load(variantId, sectionId);
    return fetch(productUrl + '?variant=' + variantId + '&section_id=' + sectionId, { cache: 'no-store' })
      .then(function (r) { return r.text(); });
  }

  /* Only the newest switch may write: a slower response for an earlier tap is dropped. */
  var videosRenderSeq = 0;

  document.addEventListener('pdp:variant-change', function (e) {
    var variantId = e.detail && e.detail.variantId;
    if (!variantId) return;

    var root = document.getElementById('pdp-videos-root');
    var grid = document.getElementById('pdp-videos-grid');
    if (!root || !grid) return;

    var productUrl = root.dataset.productUrl;
    var sectionId = root.dataset.sectionId;
    if (!productUrl || !sectionId) return;

    var seq = ++videosRenderSeq;
    grid.classList.add('is-loading');

    loadVideosRender(productUrl, sectionId, variantId)
      .then(function (html) {
        if (seq !== videosRenderSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('pdp-videos-grid');
        if (newGrid) {
          grid.setAttribute('data-feature-size', newGrid.getAttribute('data-feature-size') || '');
          grid.innerHTML = newGrid.innerHTML;
          initVideos(grid);
          /* Hand the new clips to the in-view observer; it releases the detached ones. */
          if (window.videoInView) window.videoInView.scan(grid);
        }
        grid.classList.remove('is-loading');
      })
      .catch(function () {
        if (seq === videosRenderSeq) grid.classList.remove('is-loading');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-and-fit"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('size-guide');
  if (!section) return;

  // Bundle: component tabs (arrow keys move between them, per the ARIA tabs pattern).
  if (section.hasAttribute('data-size-fit-bundle')) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var select = function (tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
    return;
  }

  var productUrl = section.dataset.productUrl;
  var sectionId = section.dataset.sectionId;
  if (!productUrl || !sectionId) return;

  /* This section's render for the variant. On the PDP it comes through
     main-product's per-variant cache (window.pdpVariantSections), which the
     swatch/size hover and touch prefetch already warmed (data-pdp-variant-section
     on the root opts in) and which makes switching back free. Without
     main-product on the page it fetches the render itself. */
  function loadRender(variantId) {
    var shared = window.pdpVariantSections;
    if (shared && typeof shared.load === 'function') return shared.load(variantId, sectionId);
    return fetch(productUrl + '?variant=' + variantId + '&section_id=' + sectionId, { cache: 'no-store' })
      .then(function (r) { return r.text(); });
  }

  /* Only the newest switch may write: a slower response for an earlier tap is dropped. */
  var renderSeq = 0;

  document.addEventListener('pdp:variant-change', function (e) {
    var variantId = e.detail && e.detail.variantId;
    if (!variantId) return;
    var seq = ++renderSeq;

    var fitsBlock = document.getElementById('size-fit-block-fits');
    var compBlock = document.getElementById('size-fit-block-comparison');
    if (fitsBlock) fitsBlock.classList.add('is-loading');
    if (compBlock) compBlock.classList.add('is-loading');

    loadRender(variantId)
      .then(function (html) {
        if (seq !== renderSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newFits = doc.getElementById('size-fit-block-fits');
        if (newFits && fitsBlock) fitsBlock.innerHTML = newFits.innerHTML;

        var newComp = doc.getElementById('size-fit-block-comparison');
        if (newComp && compBlock) compBlock.innerHTML = newComp.innerHTML;

        var newSub = doc.querySelector('[data-size-fit-subtitle]');
        var curSub = document.querySelector('[data-size-fit-subtitle]');
        if (newSub && curSub) {
          curSub.textContent = newSub.textContent;
          curSub.style.display = newSub.textContent ? '' : 'none';
        }

        if (fitsBlock) fitsBlock.classList.remove('is-loading');
        if (compBlock) compBlock.classList.remove('is-loading');
      })
      .catch(function () {
        if (seq !== renderSeq) return;
        if (fitsBlock) fitsBlock.classList.remove('is-loading');
        if (compBlock) compBlock.classList.remove('is-loading');
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ways-to-carry"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-wtc]');
  if (!section) return;
  var grid = section.querySelector('[data-wtc-grid]');
  if (!grid) return;
  var tiles = Array.prototype.slice.call(grid.querySelectorAll('.wtc__tile'));

  var activeSwatch = document.querySelector('.swatch-btn.is-active');
  var activeSize = document.querySelector('.size-btn.is-active');
  var currentColor = activeSwatch ? activeSwatch.dataset.color : '';
  var currentSize = activeSize ? activeSize.dataset.size : '';

  // Mirrors the Liquid scope-matching: 'all'/empty -> always, bare colour or
  // size -> that axis only, 'colour / size' -> exact combination.
  function matches(scope, color, size) {
    scope = (scope || '').toLowerCase().trim();
    if (scope === '' || scope === 'all') return true;
    color = (color || '').toLowerCase().trim();
    size = (size || '').toLowerCase().trim();
    if (color && scope === color) return true;
    if (size && scope === size) return true;
    if (color && size && scope === color + ' / ' + size) return true;
    return false;
  }

  function apply() {
    var visible = 0;
    tiles.forEach(function (t) {
      var show = matches(t.getAttribute('data-wtc-scope'), currentColor, currentSize);
      t.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });
    for (var n = 1; n <= 8; n++) grid.classList.remove('wtc__grid--' + n);
    grid.classList.add('wtc__grid--' + Math.min(Math.max(visible, 1), 4));
    section.classList.toggle('is-hidden', visible === 0);
  }

  // Bundle: each tile follows its own component's colour and size.
  if (section.hasAttribute('data-wtc-bundle')) {
    document.addEventListener('pdp:bundle-change', function (e) {
      var parts = (e.detail && e.detail.parts) || [];
      var visible = 0;
      tiles.forEach(function (t) {
        var part = parts[parseInt(t.getAttribute('data-wtc-part'), 10)] || {};
        var show = matches(t.getAttribute('data-wtc-scope'), part.color, part.size);
        t.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      section.classList.toggle('is-hidden', visible === 0);
    });
    return;
  }

  document.addEventListener('pdp:color-change', function (e) {
    currentColor = e.detail.color;
    apply();
  });
  document.addEventListener('pdp:size-change', function (e) {
    currentSize = e.detail.size;
    apply();
  });

  apply();
})();

  } catch(e) { console.error(e); }
})();
})();
